// MF Filter Cartridge Products Data
export const mfFilterCartridgeProducts = {
  'hfpc-series': {
    id: 'hfpc-series',
    title: 'HFPC Series High Flow Pleated Cartridge Filters',
    name: 'HFPC Series High Flow Pleated Cartridge Filters',
    shortDescription: 'Large filter area and depth filtration provides a long lifetime with optimal efficiency of solids removal.',
    description: 'High flow pleated cartridge filters with large filter area and depth filtration for extended lifetime and cost-effective operation.',
    longDescription: 'HFPC Series High Flow Pleated Cartridge Filters offer exceptional performance with large filter area and depth filtration technology. The absolute glass fiber media provides optimal efficiency for solids removal, while the pleated design ensures extended service life and reduced operational costs. These filters are ideal for high-flow applications across various industries.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/085e0fcb805141d581023278e80cc79a.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'Large filter area and depth filtration for long lifetime',
      'Low cost operation with reduced labor costs',
      'Absolute glass fiber media for optimal efficiency',
      'Multiple media options: PP, PE, GF (Glass Fiber)',
      'Various micron ratings available',
      'Multiple length options: 10", 20", 30", 40"',
      'High flow rate capability',
      'Temperature resistant up to 80°C'
    ],
    applications: [
      'Oil field water treatment',
      'Power plant circulated water treatment',
      'Chemical processing',
      'Oil & Gas industry',
      'Process water treatment',
      'Electronics manufacturing',
      'Coatings and paint industry',
      'Petroleum refining'
    ],
    specifications: {
      'Filter Media': 'PP, PE, GF (Glass Fiber)',
      'Support Layer': 'PP',
      'Core/End Adaptor': 'PP',
      'Cage': 'PP',
      'Filtration Area': '0.55m² per 10" length',
      'Outer Diameter': '64mm',
      'Inner Diameter': '28mm',
      'Nominal Length': '10", 20", 30", 40"',
      'Max. Differential Pressure (Forward)': '75psi (5.1bar) at 20°C / 45psi (3.1bar) at 65°C',
      'Filter Change Recommended': '36psi (2.5bar)',
      'Max. Operating Temperature': '80°C',
      'Micron Rating PP/PE': 'Nominal 1, 2, 5...μm',
      'Micron Rating GF': 'Absolute 1, 2, 5...μm ß5000 (99.98% efficiency)'
    },
    technicalData: {
      'Pressure Drop vs. Flowrate @ 20°C Per 10"': [
        {
          flowrate: '0',
          '1μm': '0.00',
          '2μm': '0.00',
          '5μm': '0.00',
          '10μm': '0.00',
          '20μm': '0.00',
          '50μm': '0.00'
        },
        {
          flowrate: '5',
          '1μm': '0.03',
          '2μm': '0.025',
          '5μm': '0.020',
          '10μm': '0.018',
          '20μm': '0.010',
          '50μm': '0.005'
        },
        {
          flowrate: '10',
          '1μm': '0.08',
          '2μm': '0.07',
          '5μm': '0.055',
          '10μm': '0.045',
          '20μm': '0.030',
          '50μm': '0.015'
        },
        {
          flowrate: '15',
          '1μm': '0.15',
          '2μm': '0.12',
          '5μm': '0.10',
          '10μm': '0.08',
          '20μm': '0.06',
          '50μm': '0.03'
        },
        {
          flowrate: '20',
          '1μm': '0.22',
          '2μm': '0.18',
          '5μm': '0.15',
          '10μm': '0.12',
          '20μm': '0.09',
          '50μm': '0.05'
        },
        {
          flowrate: '25',
          '1μm': '0.30',
          '2μm': '0.24',
          '5μm': '0.20',
          '10μm': '0.16',
          '20μm': '0.12',
          '50μm': '0.07'
        },
        {
          flowrate: '30',
          '1μm': '0.37',
          '2μm': '0.30',
          '5μm': '0.25',
          '10μm': '0.20',
          '20μm': '0.15',
          '50μm': '0.09'
        },
        {
          flowrate: '35',
          '1μm': '0.46',
          '2μm': '0.36',
          '5μm': '0.30',
          '10μm': '0.25',
          '20μm': '0.18',
          '50μm': '0.11'
        },
        {
          flowrate: '40',
          '1μm': '0.55',
          '2μm': '0.42',
          '5μm': '0.34',
          '10μm': '0.30',
          '20μm': '0.21',
          '50μm': '0.13'
        },
        {
          flowrate: '45',
          '1μm': '0.60',
          '2μm': '0.48',
          '5μm': '0.38',
          '10μm': '0.34',
          '20μm': '0.24',
          '50μm': '0.15'
        }
      ],
      'Ordering Guide': [
        {
          model: 'HFPC-PP-100-3-E-10',
          media: 'Polypropylene',
          micronRating: '1 µm',
          endAdaptor: '222 / Flat Closed',
          seal: 'EPDM',
          length: '10"'
        },
        {
          model: 'HFPC-PP-200-3-E-10',
          media: 'Polypropylene',
          micronRating: '2 µm',
          endAdaptor: '222 / Flat Closed',
          seal: 'EPDM',
          length: '10"'
        },
        {
          model: 'HFPC-PP-500-3-E-10',
          media: 'Polypropylene',
          micronRating: '5 µm',
          endAdaptor: '222 / Flat Closed',
          seal: 'EPDM',
          length: '10"'
        },
        {
          model: 'HFPC-PE-100-3-E-20',
          media: 'Polyester Cellulose',
          micronRating: '1 µm',
          endAdaptor: '222 / Flat Closed',
          seal: 'EPDM',
          length: '20"'
        },
        {
          model: 'HFPC-PE-200-3-E-20',
          media: 'Polyester Cellulose',
          micronRating: '2 µm',
          endAdaptor: '222 / Flat Closed',
          seal: 'EPDM',
          length: '20"'
        },
        {
          model: 'HFPC-GF-100-3-V-30',
          media: 'Glass Fiber',
          micronRating: '1 µm',
          endAdaptor: '222 / Flat Closed',
          seal: 'Viton',
          length: '30"'
        },
        {
          model: 'HFPC-GF-200-3-V-40',
          media: 'Glass Fiber',
          micronRating: '2 µm',
          endAdaptor: '222 / Flat Closed',
          seal: 'Viton',
          length: '40"'
        }
      ]
    },
    models: [
      {
        model: 'HFPC-PP-100-3-E-10',
        media: 'Polypropylene',
        micronRating: '1 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'EPDM',
        length: '10"'
      },
      {
        model: 'HFPC-PP-200-3-E-10',
        media: 'Polypropylene',
        micronRating: '2 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'EPDM',
        length: '10"'
      },
      {
        model: 'HFPC-PP-500-3-E-10',
        media: 'Polypropylene',
        micronRating: '5 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'EPDM',
        length: '10"'
      },
      {
        model: 'HFPC-PE-100-3-E-20',
        media: 'Polyester Cellulose',
        micronRating: '1 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'EPDM',
        length: '20"'
      },
      {
        model: 'HFPC-PE-200-3-E-20',
        media: 'Polyester Cellulose',
        micronRating: '2 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'EPDM',
        length: '20"'
      },
      {
        model: 'HFPC-GF-100-3-V-30',
        media: 'Glass Fiber',
        micronRating: '1 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'Viton',
        length: '30"'
      },
      {
        model: 'HFPC-GF-200-3-V-40',
        media: 'Glass Fiber',
        micronRating: '2 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'Viton',
        length: '40"'
      }
    ]
  },
  'ptfe-membrane': {
    id: 'ptfe-membrane',
    title: 'PTFE Membrane Pleated Filter Cartridge',
    name: 'PTFE Membrane Pleated Filter Cartridge',
    shortDescription: 'Hydrophobic PTFE membrane pleated cartridges with absolutely rated filtration for gas and liquid applications.',
    description: 'Superior flow rate and efficiency maximizing performance with extremely good chemical compatibility and high temperature resistance.',
    longDescription: 'PTFE Membrane Pleated Filter Cartridges feature hydrophobic PTFE membrane with thermally bonded polypropylene components to provide a very durable filter with only two materials of construction. These cartridges remove particles and microorganisms greater than 0.2µm from gas and liquid, offering superior flow rate and efficiency while maximizing performance across extensive applications.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/883bc7bd103137a0e33ccb3946b167ea.png',
    category: 'MF Filter Cartridge',
    features: [
      'Hydrophobic PTFE membrane pleated cartridges with absolutely rated filtration',
      'PTFE membrane with thermally bonded polypropylene components',
      'Superior flow rate and efficiency maximizing performance',
      'Extensive applicability with extremely good chemical compatibility',
      'Good oxidation-resistance and high temperature-resistance',
      'Remove particles and microorganisms greater than 0.2µm from gas and liquid',
      '100% integrity tested by bubble point and diffusional flow',
      'Flushed with ultrapure water to remove manufacturing debris',
      'No adhesive, thermal bonded manufacturing without adhesives'
    ],
    applications: [
      'Solvent filtration',
      'Sterile vent filters for storage tanks',
      'Coating-solvent in the electronic industry',
      'Filtration of non-aqueous chemicals',
      'Filtration of acid baths for the production of semiconductors',
      'Compressed Gas',
      'Pharmaceutical and intermediate Solvents'
    ],
    specifications: {
      'Media': 'Hydrophobic PTFE',
      'Support Layer': 'Polypropylene',
      'Core/Cage/End Adaptor': 'Polypropylene',
      'Sealing Method': 'Thermal bonding',
      'Max. Differential Pressure (Forward)': '70 psi (4.8 bar) at 25°C',
      'Max. Differential Pressure (Reverse)': '40 psi (2.7 bar) at 25°C',
      'Filter Change Recommended': '1.5 bar',
      'Max. Operating Temperature': '95°C',
      'Filtration Area': '0.75 m² per 10" length',
      'Outer Diameter': '69 mm',
      'Nominal Length': '5", 10", 20", 30", 40"',
      'Micron Rating': '0.1, 0.2, 0.45 µm'
    },
    technicalData: {
      'Integrity Test Values': [
        {
          'Micro Pore Size': '0.1 µm',
          '100% IPA Bubble Point': '22 Psig (1.5 Bar)'
        },
        {
          'Micro Pore Size': '0.2 µm',
          '100% IPA Bubble Point': '15 Psig (1.0 Bar)'
        },
        {
          'Micro Pore Size': '0.45 µm',
          '100% IPA Bubble Point': '9 Psig (0.6 Bar)'
        }
      ],
      'Ordering Guide': [
        {
          'Model': 'PTFE -',
          'Micron Rating': '010: 0.1μm',
          'End Adaptor CODE': 'O - DOE Double Open End',
          'Seal': 'E - EPDM',
          'Length': '10: 10"'
        },
        {
          'Model': 'PTFE Pleated Type',
          'Micron Rating': '020: 0.2μm',
          'End Adaptor CODE': '7 - 226/Fin',
          'Seal': 'N - Buna',
          'Length': '20: 20"'
        },
        {
          'Model': '',
          'Micron Rating': '045: 0.45μm',
          'End Adaptor CODE': '8 - 222/Fin',
          'Seal': 'S - Silicon',
          'Length': '30: 30"'
        },
        {
          'Model': '',
          'Micron Rating': '',
          'End Adaptor CODE': '3 - 222/Flat Closed',
          'Seal': 'V - Viton',
          'Length': '40: 40"'
        },
        {
          'Model': '',
          'Micron Rating': '',
          'End Adaptor CODE': '2 - 226/Flat Closed',
          'Seal': '',
          'Length': ''
        },
        {
          'Model': '',
          'Micron Rating': '',
          'End Adaptor CODE': 'F - 215/Flat Closed',
          'Seal': '',
          'Length': ''
        },
        {
          'Model': '',
          'Micron Rating': '',
          'End Adaptor CODE': 'S - O-Ring Insert/Flat Closed',
          'Seal': '',
          'Length': ''
        }
      ]
    },
    models: [
      {
        model: 'PTFE-010-O-E-10',
        media: 'Hydrophobic PTFE',
        micronRating: '0.1 µm',
        endAdaptor: 'DOE Double Open End',
        seal: 'EPDM',
        length: '10"'
      },
      {
        model: 'PTFE-020-3-V-10',
        media: 'Hydrophobic PTFE',
        micronRating: '0.2 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'Viton',
        length: '10"'
      },
      {
        model: 'PTFE-045-7-S-20',
        media: 'Hydrophobic PTFE',
        micronRating: '0.45 µm',
        endAdaptor: '226 / Fin',
        seal: 'Silicon',
        length: '20"'
      },
      {
        model: 'PTFE-010-8-N-30',
        media: 'Hydrophobic PTFE',
        micronRating: '0.1 µm',
        endAdaptor: '222 / Fin',
        seal: 'Buna',
        length: '30"'
      },
      {
        model: 'PTFE-020-F-V-40',
        media: 'Hydrophobic PTFE',
        micronRating: '0.2 µm',
        endAdaptor: '215 / Flat Closed',
        seal: 'Viton',
        length: '40"'
      },
      {
        model: 'PTFE-045-S-E-5',
        media: 'Hydrophobic PTFE',
        micronRating: '0.45 µm',
        endAdaptor: 'O-Ring Insert / Flat Closed',
        seal: 'EPDM',
        length: '5"'
      }
    ]
  },
  'pp-membrane': {
    id: 'pp-membrane',
    title: 'PP Membrane Pleated Filter Cartridge',
    name: 'PP Membrane Pleated Filter Cartridge',
    shortDescription: 'High surface area polypropylene membrane pleated cartridges with increased dirt holding capacity and longer service life.',
    description: 'Constructed of all polypropylene high purity media, meets FDA requirements with multiple layered micro-porous construction.',
    longDescription: 'PP Membrane Pleated Filter Cartridges feature high surface area with wide selection of micron rating to meet different filtration requirements. Constructed entirely of polypropylene high purity media that meets FDA requirements, these cartridges provide increased dirt holding capacity and longer service life. The multiple layered micro-porous construction ensures consistent filtration performance with thermal bonded manufacturing for high durability.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/883bc7bd103137a0e33ccb3946b167ea.png',
    category: 'MF Filter Cartridge',
    features: [
      'High surface area for enhanced filtration performance',
      'Wide selection of micron rating to meet different filtration requirements',
      'Increased dirt holding capacity and longer service life',
      'Constructed of all polypropylene high purity media, meets FDA requirements',
      'Multiple layered micro-porous construction ensures consistent filtration performance',
      'No adhesive, thermal bonded manufacturing enable smallest contaminant extraction',
      'High durability with thermal bonded construction'
    ],
    applications: [
      'Pre-filtration or RO system, DI water',
      'Solvents, selected acids & lyes, chemical industry',
      'Semiconductor, Electronic industry ultrapure water system',
      'Food and beverage, drinking water treatment',
      'Oil industry'
    ],
    specifications: {
      'Media': 'Polypropylene',
      'Support Layer': 'Polypropylene',
      'Core/Cage/End Adaptor': 'Polypropylene',
      'Sealing Method': 'Thermal bonding',
      'Max. Differential Pressure (Forward)': '75 psi (5.1 bar) at 25°C / 25 psi (1.7 bar) at 80°C',
      'Max. Differential Pressure (Reverse)': '30 psi (2.0 bar) at 25°C',
      'Filter Change Recommended': '1.5–2.0 bar',
      'Max. Operating Temperature': '80°C',
      'Sterilization': '5 times, 20 minutes cycles at 121°C',
      'Filtration Area': '0.5 m² per 10" length',
      'Outer Diameter': '69 mm',
      'Nominal Length': '5", 10", 20", 30", 40"',
      'Micron Rating': '0.1, 0.2, 0.45, 0.65, 1, 3, 5 ... µm'
    },
    technicalData: {
      'Pressure Drop vs. Flowrate @ 20°C Per 10"': [
        {
          'Flowrate (LPM)': '5',
          '1 µm (PSI)': '0.03',
          '2 µm (PSI)': '0.025',
          '5 µm (PSI)': '0.020',
          '10 µm (PSI)': '0.018',
          '20 µm (PSI)': '0.010',
          '50 µm (PSI)': '0.005'
        },
        {
          'Flowrate (LPM)': '10',
          '1 µm (PSI)': '0.08',
          '2 µm (PSI)': '0.07',
          '5 µm (PSI)': '0.055',
          '10 µm (PSI)': '0.045',
          '20 µm (PSI)': '0.030',
          '50 µm (PSI)': '0.015'
        },
        {
          'Flowrate (LPM)': '15',
          '1 µm (PSI)': '0.15',
          '2 µm (PSI)': '0.12',
          '5 µm (PSI)': '0.10',
          '10 µm (PSI)': '0.08',
          '20 µm (PSI)': '0.06',
          '50 µm (PSI)': '0.03'
        },
        {
          'Flowrate (LPM)': '20',
          '1 µm (PSI)': '0.22',
          '2 µm (PSI)': '0.18',
          '5 µm (PSI)': '0.15',
          '10 µm (PSI)': '0.12',
          '20 µm (PSI)': '0.09',
          '50 µm (PSI)': '0.05'
        },
        {
          'Flowrate (LPM)': '25',
          '1 µm (PSI)': '0.30',
          '2 µm (PSI)': '0.24',
          '5 µm (PSI)': '0.20',
          '10 µm (PSI)': '0.16',
          '20 µm (PSI)': '0.12',
          '50 µm (PSI)': '0.07'
        },
        {
          'Flowrate (LPM)': '30',
          '1 µm (PSI)': '0.37',
          '2 µm (PSI)': '0.30',
          '5 µm (PSI)': '0.25',
          '10 µm (PSI)': '0.20',
          '20 µm (PSI)': '0.15',
          '50 µm (PSI)': '0.09'
        },
        {
          'Flowrate (LPM)': '35',
          '1 µm (PSI)': '0.46',
          '2 µm (PSI)': '0.36',
          '5 µm (PSI)': '0.30',
          '10 µm (PSI)': '0.25',
          '20 µm (PSI)': '0.18',
          '50 µm (PSI)': '0.11'
        },
        {
          'Flowrate (LPM)': '40',
          '1 µm (PSI)': '0.55',
          '2 µm (PSI)': '0.42',
          '5 µm (PSI)': '0.34',
          '10 µm (PSI)': '0.30',
          '20 µm (PSI)': '0.21',
          '50 µm (PSI)': '0.13'
        },
        {
          'Flowrate (LPM)': '45',
          '1 µm (PSI)': '0.60',
          '2 µm (PSI)': '0.48',
          '5 µm (PSI)': '0.38',
          '10 µm (PSI)': '0.34',
          '20 µm (PSI)': '0.24',
          '50 µm (PSI)': '0.15'
        }
      ],
      'PTFE Integrity Test Values': [
        {
          'Micro Pore Size': '0.1 µm',
          '100% IPA Bubble Point': '22 Psig (1.5 Bar)'
        },
        {
          'Micro Pore Size': '0.2 µm',
          '100% IPA Bubble Point': '15 Psig (1.0 Bar)'
        },
        {
          'Micro Pore Size': '0.45 µm',
          '100% IPA Bubble Point': '9 Psig (0.6 Bar)'
        }
      ],
      'Ordering Guide': [
        {
          'Model': 'PPL - PP Pleated Type',
          'Micron Rating': '0.10: 0.1μm',
          'End Adaptor CODE': 'O - DOE Double Open End',
          'Seal': 'E - EPDM',
          'Length': '5: 5"'
        },
        {
          'Model': '',
          'Micron Rating': '0.20: 0.2μm',
          'End Adaptor CODE': '7 - 226/Fin',
          'Seal': 'N - Buna',
          'Length': '10: 10"'
        },
        {
          'Model': '',
          'Micron Rating': '0.45: 0.45μm',
          'End Adaptor CODE': '8 - 222/Fin',
          'Seal': 'S - Silicon',
          'Length': '20: 20"'
        },
        {
          'Model': '',
          'Micron Rating': '100: 1μm',
          'End Adaptor CODE': '3 - 222/Flat Closed',
          'Seal': 'V - Viton',
          'Length': '30: 30"'
        },
        {
          'Model': '',
          'Micron Rating': '300: 3μm',
          'End Adaptor CODE': '2 - 226/Flat Closed',
          'Seal': 'T - Teflon/Encapsulated Viton',
          'Length': '40: 40"'
        },
        {
          'Model': '',
          'Micron Rating': 'H10: 10μm',
          'End Adaptor CODE': 'F - 215/Flat Closed',
          'Seal': '',
          'Length': ''
        },
        {
          'Model': '',
          'Micron Rating': '',
          'End Adaptor CODE': 'S - O-Ring Insert/Flat Closed',
          'Seal': '',
          'Length': ''
        }
      ]
    },
    models: [
      {
        model: 'PPL-0.10-O-E-10',
        media: 'Polypropylene',
        micronRating: '0.1 µm',
        endAdaptor: 'DOE Double Open End',
        seal: 'EPDM',
        length: '10"'
      },
      {
        model: 'PPL-0.20-3-V-10',
        media: 'Polypropylene',
        micronRating: '0.2 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'Viton',
        length: '10"'
      },
      {
        model: 'PPL-0.45-7-S-20',
        media: 'Polypropylene',
        micronRating: '0.45 µm',
        endAdaptor: '226 / Fin',
        seal: 'Silicon',
        length: '20"'
      },
      {
        model: 'PPL-100-8-N-30',
        media: 'Polypropylene',
        micronRating: '1 µm',
        endAdaptor: '222 / Fin',
        seal: 'Buna',
        length: '30"'
      },
      {
        model: 'PPL-300-F-T-40',
        media: 'Polypropylene',
        micronRating: '3 µm',
        endAdaptor: '215 / Flat Closed',
        seal: 'Teflon/Encapsulated Viton',
        length: '40"'
      },
      {
        model: 'PPL-H10-S-E-5',
        media: 'Polypropylene',
        micronRating: '10 µm',
        endAdaptor: 'O-Ring Insert / Flat Closed',
        seal: 'EPDM',
        length: '5"'
      }
    ]
  },
  'pes-membrane': {
    id: 'pes-membrane',
    title: 'PES Membrane Pleated Filter Cartridge',
    name: 'PES Membrane Pleated Filter Cartridge',
    shortDescription: 'Unique hydrophilic polyethersulfone cartridges with absolutely rated filtration and broad chemical compatibility.',
    description: 'Superior chemical compatibility with physiological inertness, 100% integrity tested for consistent and reliable performance.',
    longDescription: 'PES Membrane Pleated Filter Cartridges feature unique hydrophilic polyethersulfone membrane with thermally bonded polypropylene components to provide a very durable filter with only two materials of construction. These cartridges offer compatibility with a broad range of chemicals and physiological inertness, making them ideal for critical filtration applications. Each cartridge is 100% integrity tested and flushed with ultrapure water to ensure consistent performance.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/883bc7bd103137a0e33ccb3946b167ea.png',
    category: 'MF Filter Cartridge',
    features: [
      'Unique hydrophilic polyethersulfone cartridges with absolutely rated filtration',
      'Polyethersulfone membrane with thermally bonded polypropylene components',
      'Compatibility with a broad range of chemicals and physiological inertness',
      '100% integrity tested by bubble point and diffusional flow',
      'Flushed with ultrapure water to remove manufacturing debris',
      'No adhesive, thermal bonded manufacturing enable smallest contaminant extraction',
      'Increased surface area with excellent flow rates'
    ],
    applications: [
      'Final filtration for bacteria removal in RO system',
      'Sterilization of food and beverages',
      'Micro-filtration in ultrapure water system',
      'Beverage and wine filtration/clarification',
      'Photographic solutions',
      'Plating solutions',
      'Magnetic coatings'
    ],
    specifications: {
      'Media': 'Hydrophilic polyethersulfone (PES)',
      'Support Layer': 'Polypropylene',
      'Core/Cage/End Adaptor': 'Polypropylene',
      'Sealing Method': 'Thermal bonding',
      'Max. Differential Pressure (Forward)': '70 psi (4.8 bar) at 25°C',
      'Max. Differential Pressure (Reverse)': '40 psi (2.7 bar) at 25°C',
      'Filter Change Recommended': '1.5 bar',
      'Max. Operating Temperature': '80°C',
      'Sterilization': '20 times, 30 minutes cycles at 121°C',
      'Filtration Area': '0.55 m² per 10" length',
      'Outer Diameter': '69 mm',
      'Nominal Length': '5", 10", 20", 30", 40"',
      'Micron Rating': '0.1, 0.2, 0.45 µm'
    },
    technicalData: {
      'Recommended Integrity Test': [
        {
          'Pore Size': '0.1 µm',
          'Minimum Water Bubble Point': '--',
          'Diffusional Flow CC/Min @ Test Pressure (10" Length)': '≤ 15 @ 48 Psig (3.3 Bar)'
        },
        {
          'Pore Size': '0.2 µm',
          'Minimum Water Bubble Point': '≥ 45 Psig (3.1 Bar)',
          'Diffusional Flow CC/Min @ Test Pressure (10" Length)': '≤ 15 @ 35 Psig (2.4 Bar)'
        },
        {
          'Pore Size': '0.45 µm',
          'Minimum Water Bubble Point': '≥ 24 Psig (1.7 Bar)',
          'Diffusional Flow CC/Min @ Test Pressure (10" Length)': '≤ 15 @ 20 Psig (1.4 Bar)'
        }
      ],
      'Ordering Guide': [
        {
          'Model': 'PES - PES Pleated Type',
          'Micron Rating': '0.10: 0.1μm',
          'End Adaptor CODE': 'O - DOE Double Open End',
          'Seal': 'E - EPDM',
          'Length': '5: 5"'
        },
        {
          'Model': '',
          'Micron Rating': '0.20: 0.2μm',
          'End Adaptor CODE': '7 - 226/Fin',
          'Seal': 'N - Buna',
          'Length': '10: 10"'
        },
        {
          'Model': '',
          'Micron Rating': '0.45: 0.45μm',
          'End Adaptor CODE': '8 - 222/Fin',
          'Seal': 'S - Silicon',
          'Length': '20: 20"'
        },
        {
          'Model': '',
          'Micron Rating': '',
          'End Adaptor CODE': '3 - 222/Flat Closed',
          'Seal': 'V - Viton',
          'Length': '30: 30"'
        },
        {
          'Model': '',
          'Micron Rating': '',
          'End Adaptor CODE': '2 - 226/Flat Closed',
          'Seal': '',
          'Length': '40: 40"'
        },
        {
          'Model': '',
          'Micron Rating': '',
          'End Adaptor CODE': 'F - 215/Flat Closed',
          'Seal': '',
          'Length': ''
        },
        {
          'Model': '',
          'Micron Rating': '',
          'End Adaptor CODE': 'S - O-Ring Insert/Flat Closed',
          'Seal': '',
          'Length': ''
        }
      ]
    },
    models: [
      {
        model: 'PES-0.10-O-E-10',
        media: 'Hydrophilic Polyethersulfone',
        micronRating: '0.1 µm',
        endAdaptor: 'DOE Double Open End',
        seal: 'EPDM',
        length: '10"'
      },
      {
        model: 'PES-0.20-3-V-10',
        media: 'Hydrophilic Polyethersulfone',
        micronRating: '0.2 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'Viton',
        length: '10"'
      },
      {
        model: 'PES-0.45-7-S-20',
        media: 'Hydrophilic Polyethersulfone',
        micronRating: '0.45 µm',
        endAdaptor: '226 / Fin',
        seal: 'Silicon',
        length: '20"'
      },
      {
        model: 'PES-0.10-8-N-30',
        media: 'Hydrophilic Polyethersulfone',
        micronRating: '0.1 µm',
        endAdaptor: '222 / Fin',
        seal: 'Buna',
        length: '30"'
      },
      {
        model: 'PES-0.20-F-V-40',
        media: 'Hydrophilic Polyethersulfone',
        micronRating: '0.2 µm',
        endAdaptor: '215 / Flat Closed',
        seal: 'Viton',
        length: '40"'
      },
      {
        model: 'PES-0.45-S-E-5',
        media: 'Hydrophilic Polyethersulfone',
        micronRating: '0.45 µm',
        endAdaptor: 'O-Ring Insert / Flat Closed',
        seal: 'EPDM',
        length: '5"'
      }
    ]
  },
  'nylon-membrane': {
    id: 'nylon-membrane',
    title: 'Nylon Membrane Pleated Filter Cartridge',
    name: 'Nylon Membrane Pleated Filter Cartridge',
    shortDescription: 'Hydrophilic Nylon 6 membrane pleated cartridges with absolutely rated performance and non-fiber releasing properties.',
    description: 'Superior flow rate and efficiency with good high temperature, acid and base resistance for pharmaceutics and food industry requirements.',
    longDescription: 'Nylon Membrane Pleated Filter Cartridges feature hydrophilic Nylon 6 membrane with thermally bonded polypropylene components to provide a very durable filter with only two materials of construction. These cartridges offer superior flow rate and efficiency while maximizing performance with non-fiber releasing properties according to pharmaceutics and food industry requirements. The cartridges provide good high temperature, acid and base resistance for critical applications.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/883bc7bd103137a0e33ccb3946b167ea.png',
    category: 'MF Filter Cartridge',
    features: [
      'Hydrophilic Nylon 6 membrane pleated cartridges with absolutely rated performance',
      'Nylon 6 membrane with thermally bonded polypropylene components',
      'Superior flow rate and efficiency maximizing performance',
      'Non-fiber releasing according to pharmaceutics and food industry requirements',
      'Good high temperature, acid and base resistance',
      'Remove particles and microorganisms greater than 0.2 µm from gas and liquid',
      '100% integrity tested by bubble point and diffusional flow',
      'Flushed with ultrapure water to remove manufacturing debris',
      'No adhesive, thermal bonded manufacturing without adhesives'
    ],
    applications: [
      'Final filtration for bacteria removal in reverse osmosis, deionization and other ultrapure water systems',
      'Particle filtration for ultrapure chemicals',
      'Semiconductor / Electronic industry ultrapure water systems',
      'Food and beverage / drinking water treatment',
      'Plating solutions',
      'Pharmaceuticals'
    ],
    specifications: {
      'Media': 'Hydrophilic Nylon (Nylon 6)',
      'Support Layer': 'Polypropylene',
      'Core/Cage/End Adaptor': 'Polypropylene',
      'Sealing Method': 'Thermal bonding',
      'Max. Differential Pressure (Forward)': '70 psi (4.8 bar) at 25°C',
      'Max. Differential Pressure (Reverse)': '40 psi (2.7 bar) at 25°C',
      'Filter Change Recommended': '1.5 bar',
      'Max. Operating Temperature': '80°C',
      'Sterilization': '20 cycles, 30 minutes each at 121°C',
      'Filtration Area': '0.65 m² per 10" length',
      'Outer Diameter': '69 mm',
      'Nominal Length': '5", 10", 20", 30", 40"',
      'Micron Rating': '0.1, 0.2, 0.45, 0.65 µm'
    },
    technicalData: {
      'Recommended Integrity Test': [
        {
          'Pore Size': '0.1 µm',
          'Diffusional Flow CC/Min @ Test Pressure (10" Length)': '≤ 55 @ 48 Psig (3.3 Bar)'
        },
        {
          'Pore Size': '0.2 µm',
          'Diffusional Flow CC/Min @ Test Pressure (10" Length)': '≤ 55 @ 35 Psig (2.4 Bar)'
        },
        {
          'Pore Size': '0.45 µm',
          'Diffusional Flow CC/Min @ Test Pressure (10" Length)': '≤ 55 @ 20 Psig (1.4 Bar)'
        },
        {
          'Pore Size': '0.65 µm',
          'Diffusional Flow CC/Min @ Test Pressure (10" Length)': '≤ 55 @ 15 Psig (1.0 Bar)'
        }
      ],
      'Ordering Guide': [
        {
          'Model': 'N6 — Nylon Membrane Pleated Filter Cartridge',
          'Micron Rating': '010: 0.1 µm',
          'End Adaptor (CODE)': 'O - DOE Double Open End',
          'Seal': 'E - EPDM',
          'Length': '5: 5"'
        },
        {
          'Model': '',
          'Micron Rating': '020: 0.2 µm',
          'End Adaptor (CODE)': '7 - 226 / Fin',
          'Seal': 'N - Buna',
          'Length': '10: 10"'
        },
        {
          'Model': '',
          'Micron Rating': '045: 4.5 µm',
          'End Adaptor (CODE)': '8 - 222 / Fin',
          'Seal': 'S - Silicone',
          'Length': '20: 20"'
        },
        {
          'Model': '',
          'Micron Rating': '065: 6.5 µm',
          'End Adaptor (CODE)': '3 - 222 / Flat Closed',
          'Seal': 'V - Viton',
          'Length': '30: 30"'
        },
        {
          'Model': '',
          'Micron Rating': '……',
          'End Adaptor (CODE)': '2 - 226 / Flat Closed',
          'Seal': 'T - Teflon / Encapsulated Viton',
          'Length': '40: 40"'
        },
        {
          'Model': '',
          'Micron Rating': '',
          'End Adaptor (CODE)': 'F - 215 / Flat Closed; S - O‑Ring Insert / Flat Closed',
          'Seal': '',
          'Length': ''
        }
      ]
    },
    models: [
      {
        model: 'N6-010-O-E-10',
        media: 'Hydrophilic Nylon 6',
        micronRating: '0.1 µm',
        endAdaptor: 'DOE Double Open End',
        seal: 'EPDM',
        length: '10"'
      },
      {
        model: 'N6-020-3-V-10',
        media: 'Hydrophilic Nylon 6',
        micronRating: '0.2 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'Viton',
        length: '10"'
      },
      {
        model: 'N6-045-7-S-20',
        media: 'Hydrophilic Nylon 6',
        micronRating: '0.45 µm',
        endAdaptor: '226 / Fin',
        seal: 'Silicone',
        length: '20"'
      },
      {
        model: 'N6-065-8-N-30',
        media: 'Hydrophilic Nylon 6',
        micronRating: '0.65 µm',
        endAdaptor: '222 / Fin',
        seal: 'Buna',
        length: '30"'
      },
      {
        model: 'N6-010-F-T-40',
        media: 'Hydrophilic Nylon 6',
        micronRating: '0.1 µm',
        endAdaptor: '215 / Flat Closed',
        seal: 'Teflon / Encapsulated Viton',
        length: '40"'
      },
      {
        model: 'N6-020-S-E-5',
        media: 'Hydrophilic Nylon 6',
        micronRating: '0.2 µm',
        endAdaptor: 'O‑Ring Insert / Flat Closed',
        seal: 'EPDM',
        length: '5"'
      }
    ]
  },
  'wf-series': {
    id: 'wf-series',
    title: 'WF Series Whole Forming Pleated Cartridge Filters',
    name: 'WF Series Whole Forming Pleated Cartridge Filters',
    shortDescription: 'Single whole piece cage and core construction with excellent chemical compatibility and graded pore density for high dirt holding capacity.',
    description: 'Pleated design with low pressure drop and long service life, suitable for filtering organic solvents, acid bases with full range of removal ratings.',
    longDescription: 'WF Series Whole Forming Pleated Cartridge Filters feature single whole piece cage and core construction with excellent chemical compatibility. These filters are suitable for filtering organic solvents, acid bases, and provide pleated design that increases filtration area while maintaining low pressure drop and long service life. The graded pore density ensures high dirt holding capacity with full range of removal ratings available.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/376b568642c9b2f87edf3ae50995d6ee.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'Single whole piece cage and core construction',
      'Excellent chemical compatibility, suitable for filtering organic solvents, acid bases',
      'Pleated design increased the filtration area',
      'Low pressure drop, long service life',
      'Full range of removal ratings',
      'Graded pore density for high dirt holding capacity'
    ],
    applications: [
      'Pharmaceutics',
      'Food and beverage',
      'Oil industry',
      'Semiconductor',
      'Chemical industry',
      'Prefiltration for RO',
      'Paints & Coatings',
      'Cosmetics',
      'Photographic and plating solutions',
      'Air and gas filtration'
    ],
    specifications: {
      'Filter Media': 'PP-Polypropylene, GF-Glass fiber',
      'Support Layer': 'PP',
      'Core/Cage/End Adaptor': 'PP',
      'Seal Material': 'Silicone, EPDM, Buna, Viton, Teflon',
      'Max. Differential Pressure (Forward)': '75psi (5.1bar) at 25°C / 25psi (1.7bar) at 80°C',
      'Max. Differential Pressure (Reverse)': '30psi (2.0bar) at 25°C',
      'Filter Change Recommended': '1.5-2.0bar',
      'Max. Operating Temperature': '80°C',
      'Sterilization': '5 times, 20 minutes cycles at 121°C',
      'Filtration Area': '0.5m² per 10" length',
      'Outer Diameter': '69mm',
      'Nominal Length': '5", 10", 20", 30", 40"',
      'Micron Rating PP': 'Nominal 0.1, 0.2, 0.45, 0.65, 1, 3, 5....μm',
      'Micron Rating GF': 'Absolute 0.45, 0.65, 1, 3, 5....μm ß5000 (99.98% efficiency)'
    },
    technicalData: {
      'GF Filter - Pressure Drop vs. Flowrate @ 20°C Per 10"': [
        {
          'Flow (GPM)': '2',
          '0.45 µm (PSI)': '0.30',
          '1 µm (PSI)': '0.26',
          '3 µm (PSI)': '0.21',
          '5 µm (PSI)': '0.17',
          '10 µm (PSI)': '0.10',
          '50 µm (PSI)': '0.02'
        },
        {
          'Flow (GPM)': '4',
          '0.45 µm (PSI)': '0.60',
          '1 µm (PSI)': '0.52',
          '3 µm (PSI)': '0.42',
          '5 µm (PSI)': '0.34',
          '10 µm (PSI)': '0.20',
          '50 µm (PSI)': '0.05'
        },
        {
          'Flow (GPM)': '6',
          '0.45 µm (PSI)': '0.90',
          '1 µm (PSI)': '0.78',
          '3 µm (PSI)': '0.63',
          '5 µm (PSI)': '0.51',
          '10 µm (PSI)': '0.30',
          '50 µm (PSI)': '0.07'
        },
        {
          'Flow (GPM)': '8',
          '0.45 µm (PSI)': '1.20',
          '1 µm (PSI)': '1.04',
          '3 µm (PSI)': '0.84',
          '5 µm (PSI)': '0.68',
          '10 µm (PSI)': '0.40',
          '50 µm (PSI)': '0.10'
        },
        {
          'Flow (GPM)': '10',
          '0.45 µm (PSI)': '1.50',
          '1 µm (PSI)': '1.30',
          '3 µm (PSI)': '1.05',
          '5 µm (PSI)': '0.85',
          '10 µm (PSI)': '0.50',
          '50 µm (PSI)': '0.12'
        }
      ],
      'PP Filter - Pressure Drop vs. Flowrate @ 20°C Per 10"': [
        {
          'Flow (LPM)': '5',
          '0.1 µm': '0.72',
          '0.22 µm': '0.31',
          '0.45 µm': '0.07',
          '1 µm': '0.05',
          '3 µm': '0.03',
          '5 µm': '0.02',
          '10 µm': '0.01',
          '20 µm': '0.01',
          '30 µm': '0.00',
          '50 µm': '0.00'
        },
        {
          'Flow (LPM)': '10',
          '0.1 µm': '1.44',
          '0.22 µm': '0.62',
          '0.45 µm': '0.13',
          '1 µm': '0.10',
          '3 µm': '0.07',
          '5 µm': '0.04',
          '10 µm': '0.03',
          '20 µm': '0.02',
          '30 µm': '0.01',
          '50 µm': '0.00'
        },
        {
          'Flow (LPM)': '15',
          '0.1 µm': '2.17',
          '0.22 µm': '0.93',
          '0.45 µm': '0.20',
          '1 µm': '0.15',
          '3 µm': '0.10',
          '5 µm': '0.07',
          '10 µm': '0.04',
          '20 µm': '0.03',
          '30 µm': '0.01',
          '50 µm': '0.01'
        },
        {
          'Flow (LPM)': '20',
          '0.1 µm': '2.89',
          '0.22 µm': '1.24',
          '0.45 µm': '0.27',
          '1 µm': '0.20',
          '3 µm': '0.13',
          '5 µm': '0.09',
          '10 µm': '0.05',
          '20 µm': '0.03',
          '30 µm': '0.02',
          '50 µm': '0.01'
        },
        {
          'Flow (LPM)': '25',
          '0.1 µm': '3.61',
          '0.22 µm': '1.56',
          '0.45 µm': '0.33',
          '1 µm': '0.25',
          '3 µm': '0.17',
          '5 µm': '0.11',
          '10 µm': '0.07',
          '20 µm': '0.04',
          '30 µm': '0.02',
          '50 µm': '0.01'
        },
        {
          'Flow (LPM)': '30',
          '0.1 µm': '4.33',
          '0.22 µm': '1.87',
          '0.45 µm': '0.40',
          '1 µm': '0.30',
          '3 µm': '0.20',
          '5 µm': '0.13',
          '10 µm': '0.08',
          '20 µm': '0.05',
          '30 µm': '0.03',
          '50 µm': '0.01'
        },
        {
          'Flow (LPM)': '35',
          '0.1 µm': '5.06',
          '0.22 µm': '2.18',
          '0.45 µm': '0.47',
          '1 µm': '0.35',
          '3 µm': '0.23',
          '5 µm': '0.16',
          '10 µm': '0.09',
          '20 µm': '0.05',
          '30 µm': '0.03',
          '50 µm': '0.02'
        },
        {
          'Flow (LPM)': '40',
          '0.1 µm': '5.78',
          '0.22 µm': '2.49',
          '0.45 µm': '0.53',
          '1 µm': '0.40',
          '3 µm': '0.27',
          '5 µm': '0.18',
          '10 µm': '0.11',
          '20 µm': '0.06',
          '30 µm': '0.04',
          '50 µm': '0.02'
        },
        {
          'Flow (LPM)': '45',
          '0.1 µm': '6.50',
          '0.22 µm': '2.80',
          '0.45 µm': '0.60',
          '1 µm': '0.45',
          '3 µm': '0.30',
          '5 µm': '0.20',
          '10 µm': '0.12',
          '20 µm': '0.07',
          '30 µm': '0.04',
          '50 µm': '0.02'
        }
      ],
      'Ordering Guide': [
        {
          'Model': 'WF - Whole Forming Pleated Type',
          'Micron Rating': '010: 0.1 µm',
          'End Adaptor (CODE)': 'O - DOE Double Open End',
          'Seal': 'E - EPDM',
          'Length': '10: 10"'
        },
        {
          'Model': '',
          'Micron Rating': '020: 0.2 µm',
          'End Adaptor (CODE)': '7 - 226 / Fin',
          'Seal': 'N - Buna',
          'Length': '20: 20"'
        },
        {
          'Model': '',
          'Micron Rating': '045: 4.5 µm',
          'End Adaptor (CODE)': '8 - 222 / Fin',
          'Seal': 'S - Silicon',
          'Length': '30: 30"'
        },
        {
          'Model': '',
          'Micron Rating': '100: 1 µm',
          'End Adaptor (CODE)': '3 - 222 / Flat Closed',
          'Seal': 'V - Viton',
          'Length': '40: 40"'
        },
        {
          'Model': '',
          'Micron Rating': '300: 3 µm',
          'End Adaptor (CODE)': '2 - 226 / Flat Closed',
          'Seal': 'T - Teflon',
          'Length': ''
        },
        {
          'Model': '',
          'Micron Rating': '……',
          'End Adaptor (CODE)': 'F - 215 / Flat Closed',
          'Seal': 'Encapsulated Viton',
          'Length': ''
        },
        {
          'Model': '',
          'Micron Rating': 'H10: 10 µm',
          'End Adaptor (CODE)': 'S - O‑Ring Insert / Flat Closed',
          'Seal': '',
          'Length': ''
        }
      ]
    },
    models: [
      {
        model: 'WF-PP-010-O-E-10',
        media: 'Polypropylene',
        micronRating: '0.1 µm',
        endAdaptor: 'DOE Double Open End',
        seal: 'EPDM',
        length: '10"'
      },
      {
        model: 'WF-PP-020-3-V-10',
        media: 'Polypropylene',
        micronRating: '0.2 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'Viton',
        length: '10"'
      },
      {
        model: 'WF-PP-100-7-S-20',
        media: 'Polypropylene',
        micronRating: '1 µm',
        endAdaptor: '226 / Fin',
        seal: 'Silicon',
        length: '20"'
      },
      {
        model: 'WF-PP-300-8-N-30',
        media: 'Polypropylene',
        micronRating: '3 µm',
        endAdaptor: '222 / Fin',
        seal: 'Buna',
        length: '30"'
      },
      {
        model: 'WF-GF-045-F-T-40',
        media: 'Glass Fiber',
        micronRating: '0.45 µm',
        endAdaptor: '215 / Flat Closed',
        seal: 'Teflon',
        length: '40"'
      },
      {
        model: 'WF-GF-100-S-E-5',
        media: 'Glass Fiber',
        micronRating: '1 µm',
        endAdaptor: 'O‑Ring Insert / Flat Closed',
        seal: 'EPDM',
        length: '5"'
      }
    ]
  },
'uhfp-d': {
    id: 'uhfp-d',
    title: 'UHFP-D Ultra Highflow Bag Filter Cartridge',
    name: 'UHFP-D Ultra Highflow Bag Filter Cartridge',
    shortDescription: 'Ultra-high flow pleated bag cartridge with 6" (152 mm) diameter for high flow and high contaminant applications; retrofits into size #1 and #2 housings.',
    description: 'Pleated PP high performance media with large filtration area and high mechanical strength. Inside-out flow traps contaminants within the element for extended service life.',
    longDescription: 'UHFP-D Ultra Highflow Bag Filter Cartridge provides a large 6" (152 mm) diameter pleated design delivering very high filtration area and high dirt holding capacity. Constructed of pleated polypropylene media with polypropylene support, end caps and adjustable flange. High mechanical strength and designed for inside-out flow to trap contaminants within the element. Suitable for seawater desalination pretreatment, RO prefiltration, food & beverage, biopharm, petrochemical and industrial water applications.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/ea01f6656e8d2d10a8c1f66c49cf05fb.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'High performance pleated PP media with high filtration area',
      'Large 6" / 152 mm cartridge diameter for very high flow and high contaminant load',
      'High mechanical strength suitable for demanding conditions',
      'Inside-out flow design traps contaminants inside the element',
      'Easily retrofit into existing size #1 and size #2 bag housings',
      'Multiple micron ratings available'
    ],
    applications: [
      'Prefiltration of RO, seawater desalination pretreatment',
      'Condensed water, make-up, rinse, process cooling water',
      'API, solvents and water filtration in BioPharm market',
      'Bottled water, high fructose, edible oil, soft drinks and milk filtration',
      'Paints and coatings, petrochemical, refineries',
      'Microelectronics, film, fiber and resin'
    ],
    specifications: {
      'Filter Media': 'Pleated Polypropylene (PP)',
      'Support / Drainage': 'Polypropylene (PP)',
      'End Caps': 'Polypropylene (PP)',
      'Adjustable Flange': 'Polypropylene (PP)',
      'O-ring Seal': 'EPDM, Buna (optional)',
      'Outside Diameter': '6" / 152 mm',
      'Length (Size #1)': '405 mm (16")',
      'Length (Size #2)': '785 mm (31")',
      'Removal Ratings': '0.5, 1, 3, 5, 10, 20, 50, 70, 100 µm',
      'Maximum Operating Temperature': 'Pleated PP 60°C',
      'Maximum Differential Pressure': 'Pleated PP 3.4 Bar @ 60°C',
      'Recommended Change-out Differential Pressure': '2.4 Bar @ 20°C',
      'Suggested Max. Flow Rate (water)': 'Size #1 – 550 LPM; Size #2 – 1100 LPM'
    },
    technicalData: {
      'Cartridge Dimensions': [
        { 'Attribute': 'Outside Diameter', 'Value': '6\" / 152 mm' },
        { 'Attribute': 'Length (Size #1)', 'Value': '405 mm (16\")' },
        { 'Attribute': 'Length (Size #2)', 'Value': '785 mm (31\")' }
      ],
      'Recommended Operating Conditions': [
        { 'Parameter': 'Maximum Operating Temperature', 'Value': 'Pleated PP 60°C' },
        { 'Parameter': 'Maximum Differential Pressure', 'Value': 'Pleated PP 3.4 Bar @ 60°C' },
        { 'Parameter': 'Recommended Change-out Differential Pressure', 'Value': '2.4 Bar @ 20°C' },
        { 'Parameter': 'Suggested Max. Flow Rate (water)', 'Value': 'Size #1 – 550 LPM; Size #2 – 1100 LPM' }
      ],
      'Ordering Guide': [
        {
          'Model': 'UHFP-D — Ultra Highflow Bag Type',
          'Media': 'PP - PP Pleated',
          'Micron Rating': '05 : 0.5 µm',
          'Flange Size': '#1 : Dia. 183 mm',
          'Seal': 'E : EPDM',
          'Flange Type': 'A : For Side Entry - Bottom Outlet Housing',
          'Length': '#1 : 405 mm (16")'
        },
        {
          'Model': '',
          'Media': '',
          'Micron Rating': '01 : 1 µm',
          'Flange Size': '#2 : Dia. 177 mm',
          'Seal': 'N : Buna',
          'Flange Type': 'B : For Top Entry - Bottom Outlet Housing',
          'Length': '#2 : 785 mm (31")'
        },
        { 'Model': '', 'Media': '', 'Micron Rating': '03 : 3 µm', 'Flange Size': '', 'Seal': '', 'Flange Type': '', 'Length': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '05 : 5 µm', 'Flange Size': '', 'Seal': '', 'Flange Type': '', 'Length': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '10 : 10 µm', 'Flange Size': '', 'Seal': '', 'Flange Type': '', 'Length': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '', 'Flange Size': '', 'Seal': '', 'Flange Type': '', 'Length': '' }
      ]
    },
    models: [
      {
        model: 'UHFP-D-05-#1-E-A-16',
        media: 'Pleated Polypropylene (PP)',
        micronRating: '0.5 µm',
        flangeSize: '#1 (Dia. 183 mm)',
        seal: 'EPDM',
        flangeType: 'Side Entry - Bottom Outlet (A)',
        length: '405 mm (16")'
      },
      {
        model: 'UHFP-D-01-#2-N-B-31',
        media: 'Pleated Polypropylene (PP)',
        micronRating: '1 µm',
        flangeSize: '#2 (Dia. 177 mm)',
        seal: 'Buna',
        flangeType: 'Top Entry - Bottom Outlet (B)',
        length: '785 mm (31")'
      },
      {
        model: 'UHFP-D-03-#1-E-A-16',
        media: 'Pleated Polypropylene (PP)',
        micronRating: '3 µm',
        flangeSize: '#1 (Dia. 183 mm)',
        seal: 'EPDM',
        flangeType: 'Side Entry - Bottom Outlet (A)',
        length: '405 mm (16")'
      },
      {
        model: 'UHFP-D-10-#2-N-B-31',
        media: 'Pleated Polypropylene (PP)',
        micronRating: '10 µm',
        flangeSize: '#2 (Dia. 177 mm)',
        seal: 'Buna',
        flangeType: 'Top Entry - Bottom Outlet (B)',
        length: '785 mm (31")'
      }
    ]
  },
  'uhfp-c': {
    id: 'uhfp-c',
    title: 'UHFP-C Ultra Highflow Filter Cartridge',
    name: 'UHFP-C Ultra Highflow Filter Cartridge',
    shortDescription: 'Ultra highflow cartridge with large 6.5" (165 mm) diameter, high dirt holding capacity and wide chemical compatibility.',
    description: 'Pleated GF or PP high-capacity media providing long service life and reduced change-outs. O-ring design prevents bypass and ensures filtration efficiency.',
    longDescription: 'UHFP-C Ultra Highflow Filter Cartridge offers high dirt holding capacity and long service life using pleated glass fiber or pleated polypropylene media. The cartridge features O-ring sealing to prevent bypass and is easy to handle, reducing manpower requirements. Suitable for RO pretreatment, seawater desalination pretreatment, power plant condensed water treatment, API and solvent filtration in biopharm, bottled beverage and edible oil filtration, petrochemical and microelectronics applications.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/34a88469f1129ebb54c0bd03436e3a5b.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'High dirt holding capacity and long service life',
      'Less cartridge change out to save labour cost',
      "O-ring design prevents bypass to ensure filtration efficiency",
      'Easy handling reduces required manpower',
      'Wide chemical compatibility for different applications'
    ],
    applications: [
      'Prefiltration of RO, Pretreatment of seawater desalination',
      'Condensed water treatment for power plants',
      'API, solvents and water filtration in BioPharm market',
      'Bottled water, high fructose, edible oil, soft drinks and milk filtration',
      'Paints and coatings, petrochemical, refineries',
      'Microelectronics, film, fiber and resin'
    ],
    specifications: {
      'Filter Media': 'Pleated Glass Fiber (GF), Pleated Polypropylene (PP)',
      'Support / Drainage': 'Polypropylene (PP)',
      'End Caps': 'Glass fiber reinforced Polypropylene',
      'O-ring Seal': 'EPDM, NBR',
      'Removal Ratings': '1, 3, 5, 10, 20, 50, 70, 100 µm',
      'Outside Diameter': '6.5" / 165 mm',
      'Length': '40" / 1005 mm',
      'Maximum Operating Temperature (GF)': '121°C',
      'Maximum Operating Temperature (PP)': '80°C',
      'Maximum Differential Pressure (GF)': '3.4 bar',
      'Maximum Differential Pressure (PP)': '3.4 bar @ 80°C',
      'Recommended Change-out Differential Pressure': '2.4 bar @ 20°C',
      'Suggested Max. Flow Rate (water)': '1300 LPM (system dependent)'
    },
    technicalData: {
      'GF Filter - Pressure Drop vs. Flowrate @ 20°C (Per 10\" equivalent)': [
        { 'Flow (GPM)': '0', '0.45 µm (PSI)': '0.00', '1 µm (PSI)': '0.00', '3 µm (PSI)': '0.00', '5 µm (PSI)': '0.00', '10 µm (PSI)': '0.00', '50 µm (PSI)': '0.00' },
        { 'Flow (GPM)': '2', '0.45 µm (PSI)': '0.30', '1 µm (PSI)': '0.26', '3 µm (PSI)': '0.21', '5 µm (PSI)': '0.17', '10 µm (PSI)': '0.10', '50 µm (PSI)': '0.02' },
        { 'Flow (GPM)': '4', '0.45 µm (PSI)': '0.60', '1 µm (PSI)': '0.52', '3 µm (PSI)': '0.42', '5 µm (PSI)': '0.34', '10 µm (PSI)': '0.20', '50 µm (PSI)': '0.05' },
        { 'Flow (GPM)': '6', '0.45 µm (PSI)': '0.90', '1 µm (PSI)': '0.78', '3 µm (PSI)': '0.63', '5 µm (PSI)': '0.51', '10 µm (PSI)': '0.30', '50 µm (PSI)': '0.07' },
        { 'Flow (GPM)': '8', '0.45 µm (PSI)': '1.20', '1 µm (PSI)': '1.04', '3 µm (PSI)': '0.84', '5 µm (PSI)': '0.68', '10 µm (PSI)': '0.40', '50 µm (PSI)': '0.10' },
        { 'Flow (GPM)': '10', '0.45 µm (PSI)': '1.50', '1 µm (PSI)': '1.30', '3 µm (PSI)': '1.05', '5 µm (PSI)': '0.85', '10 µm (PSI)': '0.50', '50 µm (PSI)': '0.12' }
      ],
      'PP Filter - Pressure Drop vs. Flowrate @ 20°C (approximated)': [
        { 'Flow (LPM)': '0', '0.1 µm (PSI)': '0.00', '0.22 µm (PSI)': '0.00', '0.45 µm (PSI)': '0.00', '1 µm (PSI)': '0.00', '3 µm (PSI)': '0.00', '5 µm (PSI)': '0.00', '10 µm (PSI)': '0.00', '20 µm (PSI)': '0.00', '30 µm (PSI)': '0.00', '50 µm (PSI)': '0.00' },
        { 'Flow (LPM)': '5', '0.1 µm (PSI)': '0.72', '0.22 µm (PSI)': '0.31', '0.45 µm (PSI)': '0.07', '1 µm (PSI)': '0.05', '3 µm (PSI)': '0.03', '5 µm (PSI)': '0.02', '10 µm (PSI)': '0.01', '20 µm (PSI)': '0.01', '30 µm (PSI)': '0.00', '50 µm (PSI)': '0.00' },
        { 'Flow (LPM)': '10', '0.1 µm (PSI)': '1.44', '0.22 µm (PSI)': '0.62', '0.45 µm (PSI)': '0.13', '1 µm (PSI)': '0.10', '3 µm (PSI)': '0.07', '5 µm (PSI)': '0.04', '10 µm (PSI)': '0.03', '20 µm (PSI)': '0.02', '30 µm (PSI)': '0.01', '50 µm (PSI)': '0.00' },
        { 'Flow (LPM)': '15', '0.1 µm (PSI)': '2.17', '0.22 µm (PSI)': '0.93', '0.45 µm (PSI)': '0.20', '1 µm (PSI)': '0.15', '3 µm (PSI)': '0.10', '5 µm (PSI)': '0.07', '10 µm (PSI)': '0.04', '20 µm (PSI)': '0.03', '30 µm (PSI)': '0.01', '50 µm (PSI)': '0.01' },
        { 'Flow (LPM)': '20', '0.1 µm (PSI)': '2.89', '0.22 µm (PSI)': '1.24', '0.45 µm (PSI)': '0.27', '1 µm (PSI)': '0.20', '3 µm (PSI)': '0.13', '5 µm (PSI)': '0.09', '10 µm (PSI)': '0.05', '20 µm (PSI)': '0.03', '30 µm (PSI)': '0.02', '50 µm (PSI)': '0.01' },
        { 'Flow (LPM)': '25', '0.1 µm (PSI)': '3.61', '0.22 µm (PSI)': '1.56', '0.45 µm (PSI)': '0.33', '1 µm (PSI)': '0.25', '3 µm (PSI)': '0.17', '5 µm (PSI)': '0.11', '10 µm (PSI)': '0.07', '20 µm (PSI)': '0.04', '30 µm (PSI)': '0.02', '50 µm (PSI)': '0.01' },
        { 'Flow (LPM)': '30', '0.1 µm (PSI)': '4.33', '0.22 µm (PSI)': '1.87', '0.45 µm (PSI)': '0.40', '1 µm (PSI)': '0.30', '3 µm (PSI)': '0.20', '5 µm (PSI)': '0.13', '10 µm (PSI)': '0.08', '20 µm (PSI)': '0.05', '30 µm (PSI)': '0.03', '50 µm (PSI)': '0.01' },
        { 'Flow (LPM)': '35', '0.1 µm (PSI)': '5.06', '0.22 µm (PSI)': '2.18', '0.45 µm (PSI)': '0.47', '1 µm (PSI)': '0.35', '3 µm (PSI)': '0.23', '5 µm (PSI)': '0.16', '10 µm (PSI)': '0.09', '20 µm (PSI)': '0.05', '30 µm (PSI)': '0.03', '50 µm (PSI)': '0.02' },
        { 'Flow (LPM)': '40', '0.1 µm (PSI)': '5.78', '0.22 µm (PSI)': '2.49', '0.45 µm (PSI)': '0.53', '1 µm (PSI)': '0.40', '3 µm (PSI)': '0.27', '5 µm (PSI)': '0.18', '10 µm (PSI)': '0.11', '20 µm (PSI)': '0.06', '30 µm (PSI)': '0.04', '50 µm (PSI)': '0.02' },
        { 'Flow (LPM)': '45', '0.1 µm (PSI)': '6.50', '0.22 µm (PSI)': '2.80', '0.45 µm (PSI)': '0.60', '1 µm (PSI)': '0.45', '3 µm (PSI)': '0.30', '5 µm (PSI)': '0.20', '10 µm (PSI)': '0.12', '20 µm (PSI)': '0.07', '30 µm (PSI)': '0.04', '50 µm (PSI)': '0.02' }
      ],
      'Ordering Guide': [
        { 'Model': 'UHFP-C — Ultra Highflow Type', 'Media': 'PP - PP Pleated; GF - Glass Fiber Pleated', 'Micron Rating': '1 : 1 µm', 'End Adaptor': 'S : Single O‑Ring', 'Seal': 'E : EPDM', 'Length Inch': '40 : 40"' },
        { 'Model': '', 'Media': '', 'Micron Rating': '3 : 3 µm', 'End Adaptor': 'D : Double O‑Ring', 'Seal': 'N : Buna', 'Length Inch': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '5 : 5 µm', 'End Adaptor': '', 'Seal': '', 'Length Inch': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '10 : 10 µm', 'End Adaptor': '', 'Seal': '', 'Length Inch': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '20 : 20 µm', 'End Adaptor': '', 'Seal': '', 'Length Inch': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '50 : 50 µm', 'End Adaptor': '', 'Seal': '', 'Length Inch': '' }
      ]
    },
    models: [
      {
        model: 'UHFP-C-1-GF-S-40',
        media: 'Pleated Glass Fiber (GF)',
        micronRating: '1 µm',
        endAdaptor: 'Single O‑Ring (S)',
        seal: 'EPDM',
        length: '40" (1005 mm)'
      },
      {
        model: 'UHFP-C-3-GF-D-40',
        media: 'Pleated Glass Fiber (GF)',
        micronRating: '3 µm',
        endAdaptor: 'Double O‑Ring (D)',
        seal: 'Buna',
        length: '40" (1005 mm)'
      },
      {
        model: 'UHFP-C-5-PP-S-40',
        media: 'Pleated Polypropylene (PP)',
        micronRating: '5 µm',
        endAdaptor: 'Single O‑Ring (S)',
        seal: 'EPDM',
        length: '40" (1005 mm)'
      },
      {
        model: 'UHFP-C-10-PP-S-40',
        media: 'Pleated Polypropylene (PP)',
        micronRating: '10 µm',
        endAdaptor: 'Single O‑Ring (S)',
        seal: 'EPDM',
        length: '40" (1005 mm)'
      }
    ]
  },
  'uhfp-b': {
    id: 'uhfp-b',
    title: 'UHFP-B Ultra Highflow Filter Cartridge',
    name: 'UHFP-B Ultra Highflow Filter Cartridge',
    shortDescription: 'Ultra highflow cartridge with 6" (152 mm) diameter, high dirt holding capacity and wide chemical compatibility.',
    description: 'Pleated GF or PP high-capacity media providing long service life and reduced change-outs. O-ring design prevents bypass to ensure filtration efficiency.',
    longDescription: 'UHFP-B Ultra Highflow Filter Cartridge offers high dirt holding capacity and long service life using pleated glass fiber or pleated polypropylene media. The cartridge features O-ring sealing to prevent bypass and easy handling to reduce manpower requirements. Suitable for RO pretreatment, seawater desalination pretreatment, power plant condensed water treatment, API and solvent filtration in biopharm, bottled beverage and edible oil filtration, petrochemical and microelectronics applications.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/923f96ca58d150076e9f615cb9707cab.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'High dirt holding capacity, long service life',
      'Less cartridge change-out to save labour cost',
      'O-ring design prevents bypass to ensure filtration efficiency',
      'Easy handling reduces required manpower',
      'Wide chemical compatibility for various applications'
    ],
    applications: [
      'Prefiltration of RO, pretreatment of seawater desalination',
      'Condensed water treatment for power plants',
      'API, solvents and water filtration in BioPharm market',
      'Bottled water, high fructose, edible oil, soft drinks and milk filtration',
      'Paints and coatings, petrochemical, refineries',
      'Microelectronics, film, fiber and resin'
    ],
    specifications: {
      'Filter Media': 'Pleated Glass Fiber (GF), Pleated Polypropylene (PP)',
      'Support / Drainage': 'Polypropylene (PP)',
      'End Caps': 'Glass fiber reinforced Polypropylene',
      'O-ring Seal': 'EPDM, NBR',
      'Removal Ratings': '1, 4.5, 6, 10, 20, 40, 70, 100 µm',
      'Outside Diameter': '6" / 152 mm',
      'Length': '40" / 1051 mm',
      'Maximum Operating Temperature (GF)': '121°C',
      'Maximum Operating Temperature (PP)': '80°C',
      'Maximum Differential Pressure (GF)': '3.4 bar',
      'Maximum Differential Pressure (PP)': '3.4 bar @ 80°C',
      'Recommended Change-out Differential Pressure': '2.4 bar @ 20°C',
      'Suggested Max. Flow Rate (water)': '1300 LPM (system dependent)'
    },
    technicalData: {
      'Ordering Guide': [
        { 'Model': 'UHFP-B — Ultra Highflow Type', 'Media': 'PP - PP Pleated; GF - Glass Fiber Pleated', 'Micron Rating': '1 : 1 µm', 'End Adaptor': 'S : Single O‑Ring', 'Seal': 'E : EPDM', 'Length Inch': '40 : 40"' },
        { 'Model': '', 'Media': '', 'Micron Rating': '4.5 : 4.5 µm', 'End Adaptor': 'D : Double O‑Ring', 'Seal': 'N : Buna', 'Length Inch': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '6 : 6 µm', 'End Adaptor': '', 'Seal': '', 'Length Inch': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '10 : 10 µm', 'End Adaptor': '', 'Seal': '', 'Length Inch': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '20 : 20 µm', 'End Adaptor': '', 'Seal': '', 'Length Inch': '' }
      ]
    },
    models: [
      {
        model: 'UHFP-B-1-GF-S-40',
        media: 'Pleated Glass Fiber (GF)',
        micronRating: '1 µm',
        endAdaptor: 'Single O‑Ring (S)',
        seal: 'EPDM',
        length: '40" (1051 mm)'
      },
      {
        model: 'UHFP-B-4.5-GF-D-40',
        media: 'Pleated Glass Fiber (GF)',
        micronRating: '4.5 µm',
        endAdaptor: 'Double O‑Ring (D)',
        seal: 'Buna',
        length: '40" (1051 mm)'
      },
      {
        model: 'UHFP-B-6-PP-S-40',
        media: 'Pleated Polypropylene (PP)',
        micronRating: '6 µm',
        endAdaptor: 'Single O‑Ring (S)',
        seal: 'EPDM',
        length: '40" (1051 mm)'
      },
      {
        model: 'UHFP-B-20-PP-D-40',
        media: 'Pleated Polypropylene (PP)',
        micronRating: '20 µm',
        endAdaptor: 'Double O‑Ring (D)',
        seal: 'Buna',
        length: '40" (1051 mm)'
      }
    ]
  },
  'uhfp-a': {
    id: 'uhfp-a',
    title: 'UHFP-A Ultra Highflow Filter Cartridge',
    name: 'UHFP-A Ultra Highflow Filter Cartridge',
    shortDescription: 'Ultra highflow cartridge with 6" (152 mm) diameter; gradient pore structure and very high per-cartridge flowrates.',
    description: 'Pleated GF, Pleated PP or Melt Blown PP media offering gradient pore structure, high dirt holding capacity and inside-out flow to trap contaminants for easy disposal.',
    longDescription: 'UHFP-A Ultra Highflow Filter Cartridge combines gradient pore structure with high surface area pleated or melt-blown media to deliver exceptional flow capacity and dirt holding. Available in 20", 40" and 60" lengths and designed for inside-out flow, UHFP-A reduces system footprint while providing robust filtration for RO pretreatment, power plant condensate, biopharm APIs and solvents, bottled beverage and industrial applications.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/328bb7ced3435ffd2e66249f8223cff9.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'Gradient pore structure',
      'High flowrate per cartridge (up to ~110 m³/h ≈ 1,833 LPM typical depending on micron/packing)',
      'Up to 50% reduction of filter system footprint (typical)',
      'Available in 20", 40" and 60" lengths',
      'Inside-out flow direction — contaminants trapped inside the cartridge'
    ],
    applications: [
      'Prefiltration of RO, pretreatment of seawater desalination',
      'Condensate water filtration and hot water recovery in power generation',
      'API, solvents and water filtration in BioPharm market',
      'Bottled water, high fructose, edible oil, soft drinks and milk filtration',
      'Paints & coatings, petrochemical, refineries',
      'Microelectronics, film, fiber and resin industries'
    ],
    specifications: {
      'Filter Media': 'Pleated Glass Fiber (GF); Pleated Polypropylene (PP); Melt Blown Polypropylene (PM)',
      'Support / Drainage': 'Polypropylene (PP)',
      'End Caps': 'Glass fiber reinforced Polypropylene',
      'O-ring Seal': 'EPDM, NBR',
      'Removal Ratings': '1, 4.5, 6, 10, 20, 40, 70, 100 µm',
      'Outside Diameter': '6" / 152 mm',
      'Lengths': '20" / 528 mm; 40" / 1022 mm; 60" / 1538 mm',
      'Maximum Operating Temperature (GF)': '121°C',
      'Maximum Operating Temperature (PP)': '82°C',
      'Maximum Operating Temperature (Melt Blown PP)': '65°C',
      'Maximum Differential Pressure (GF)': '4.0 bar',
      'Maximum Differential Pressure (PP)': '4.0 bar',
      'Maximum Differential Pressure (Melt Blown PP)': '2.5 bar',
      'Recommended Change-out Differential Pressure': '1.5 bar @ 20°C',
      'Suggested Flowrate (typical per cartridge)': '20": 250–660 LPM; 40": 500–1,300 LPM; 60": 800–1,900 LPM',
      'Suggested System Max Flow (typical)': 'Up to 110 m³/h (≈ 1,833 LPM) per cartridge (depends on micron/packing)'
    },
    technicalData: {
      'Suggested Flowrate (typical per cartridge)': [
        { 'Length': '20" / 528 mm', 'Flow Range (LPM)': '250 - 660' },
        { 'Length': '40" / 1022 mm', 'Flow Range (LPM)': '500 - 1,300' },
        { 'Length': '60" / 1538 mm', 'Flow Range (LPM)': '800 - 1,900' }
      ],
      'Recommended Operating Conditions': [
        { 'Parameter': 'Max. Operating Temp (GF)', 'Value': '121°C' },
        { 'Parameter': 'Max. Operating Temp (PP)', 'Value': '82°C' },
        { 'Parameter': 'Max. Operating Temp (Melt Blown PP)', 'Value': '65°C' },
        { 'Parameter': 'Max. Differential Pressure (GF)', 'Value': '4.0 bar' },
        { 'Parameter': 'Max. Differential Pressure (PP)', 'Value': '4.0 bar' },
        { 'Parameter': 'Max. Differential Pressure (Melt Blown PP)', 'Value': '2.5 bar' },
        { 'Parameter': 'Recommended Change-out DP', 'Value': '1.5 bar @ 20°C' }
      ],
      'Ordering Guide': [
        { 'Model': 'UHFP-A — Ultra Highflow Type', 'Media': 'PP - PP Pleated', 'Micron Rating': '1 : 1 µm', 'Outer Structure': 'B : Bandage', 'Seal': 'E : EPDM', 'Length Inch': '20 : 20"' },
        { 'Model': '', 'Media': 'PM - PP Melt Blown', 'Micron Rating': '4.5 : 4.5 µm', 'Outer Structure': 'C : Cage', 'Seal': 'N : Buna', 'Length Inch': '40 : 40"' },
        { 'Model': '', 'Media': 'GF - Glass Fiber Pleated', 'Micron Rating': '6 : 6 µm', 'Outer Structure': 'B : Bandage', 'Seal': 'E : EPDM', 'Length Inch': '60 : 60"' },
        { 'Model': '', 'Media': '', 'Micron Rating': '10 : 10 µm', 'Outer Structure': '', 'Seal': '', 'Length Inch': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '20 : 20 µm', 'Outer Structure': '', 'Seal': '', 'Length Inch': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '40 : 40 µm', 'Outer Structure': '', 'Seal': '', 'Length Inch': '' }
      ]
    },
    models: [
      {
        model: 'UHFP-A-1-PP-B-E-20',
        media: 'Pleated Polypropylene (PP)',
        micronRating: '1 µm',
        outerStructure: 'Bandage (B)',
        seal: 'EPDM',
        length: '20" (528 mm)'
      },
      {
        model: 'UHFP-A-4.5-PM-C-N-40',
        media: 'Melt Blown Polypropylene (PM)',
        micronRating: '4.5 µm',
        outerStructure: 'Cage (C)',
        seal: 'Buna',
        length: '40" (1022 mm)'
      },
      {
        model: 'UHFP-A-6-GF-B-E-60',
        media: 'Pleated Glass Fiber (GF)',
        micronRating: '6 µm',
        outerStructure: 'Bandage (B)',
        seal: 'EPDM',
        length: '60" (1538 mm)'
      },
      {
        model: 'UHFP-A-10-PP-C-N-40',
        media: 'Pleated Polypropylene (PP)',
        micronRating: '10 µm',
        outerStructure: 'Cage (C)',
        seal: 'Buna',
        length: '40" (1022 mm)'
      }
    ]
  },
  'string-wound': {
    id: 'string-wound',
    title: 'String Wound Cartridge Filters',
    name: 'String Wound Cartridge Filters',
    shortDescription: 'String-wound cartridges with enhanced wound design for improved dirt-holding capacity; nominal ratings 1–150 µm.',
    description: 'String wound filter cartridges for pre-filtration with enhanced wound geometry for higher dirt-holding capacity and long service life. Materials available for potable / edible products (FDA listed) and high-temperature/chemical applications.',
    longDescription: 'String Wound Cartridge Filters provide versatile nominal filtration from 1 µm up to 150 µm with yarn options including polypropylene, cotton and glass fiber. Enhanced wound designs increase dirt holding compared to standard wound cartridges. Available with polypropylene or stainless steel cores for a wide range of chemical and temperature environments. Typical applications include industrial water, beverages, pharmaceuticals, plating solutions and high-temperature chemical filtration.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/b5ebc937f6c21d9a0b7f0249ed266752.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'Used in pre-filter applications',
      'Enhanced wound design for improved dirt-holding capacity over standard wound cartridges',
      'Long service life',
      'Materials FDA listed as acceptable for potable and edible products',
      'Nominal micron rating range: 1–150 µm'
    ],
    applications: [
      'Cotton wound: organic solvents, water, oil, alkalinity solvents, beverage, pharmaceuticals',
      'Polypropylene (PP) wound: water, dilute acids, oxidizing agents, plating solutions',
      'Glass fiber wound: chemicals, organic solvents, strong acid/alkali, high temperature applications'
    ],
    specifications: {
      'Yarn / Media': 'Polypropylene (PP), Cotton, Glass Fiber',
      'Core': 'Polypropylene (PP) or Stainless Steel (SS)',
      'Nominal Micron Ratings': '1, 3, 5 ... up to 150 µm',
      'Max. Differential Pressure': '4.5 bar @ 25°C',
      'Recommended Change-out Differential Pressure': '1–1.5 bar',
      'Max. Temperature (typical combos)': 'PP yarn + PP core: 80°C; Cotton yarn + SS core: 180°C; Glass fiber + SS core: 200°C',
      'Typical ID/OD': 'ID 28 mm; OD 62–115 mm (varies by series S/B)',
      'Length Options': '5", 10", 20", 30", 40", 50", 60"'
    },
    technicalData: {
      'Pressure Drop vs. Flowrate @ 20°C (approx)': [
        { 'Flowrate (LPM)': '5', '1 µm (PSI)': '0.15', '5 µm (PSI)': '0.06', '10 µm (PSI)': '0.05', '50 µm (PSI)': '0.02', '100 µm (PSI)': '0.01' },
        { 'Flowrate (LPM)': '10', '1 µm (PSI)': '0.50', '5 µm (PSI)': '0.18', '10 µm (PSI)': '0.12', '50 µm (PSI)': '0.04', '100 µm (PSI)': '0.03' },
        { 'Flowrate (LPM)': '15', '1 µm (PSI)': '0.90', '5 µm (PSI)': '0.35', '10 µm (PSI)': '0.25', '50 µm (PSI)': '0.08', '100 µm (PSI)': '0.06' },
        { 'Flowrate (LPM)': '20', '1 µm (PSI)': '1.30', '5 µm (PSI)': '0.55', '10 µm (PSI)': '0.40', '50 µm (PSI)': '0.12', '100 µm (PSI)': '0.09' },
        { 'Flowrate (LPM)': '25', '1 µm (PSI)': '1.70', '5 µm (PSI)': '0.70', '10 µm (PSI)': '0.55', '50 µm (PSI)': '0.17', '100 µm (PSI)': '0.12' },
        { 'Flowrate (LPM)': '30', '1 µm (PSI)': '2.00', '5 µm (PSI)': '0.90', '10 µm (PSI)': '0.65', '50 µm (PSI)': '0.20', '100 µm (PSI)': '0.15' },
        { 'Flowrate (LPM)': '35', '1 µm (PSI)': '2.30', '5 µm (PSI)': '1.05', '10 µm (PSI)': '0.75', '50 µm (PSI)': '0.24', '100 µm (PSI)': '0.18' },
        { 'Flowrate (LPM)': '40', '1 µm (PSI)': '2.60', '5 µm (PSI)': '1.20', '10 µm (PSI)': '0.85', '50 µm (PSI)': '0.28', '100 µm (PSI)': '0.21' },
        { 'Flowrate (LPM)': '45', '1 µm (PSI)': '2.90', '5 µm (PSI)': '1.35', '10 µm (PSI)': '0.95', '50 µm (PSI)': '0.32', '100 µm (PSI)': '0.24' }
      ],
      'Ordering Guide': [
        {
          'Model': 'SW-1 / SW-2 / SW-3',
          'Material': 'PP (PP wound) / Cotton / Glass Fiber',
          'Support Core': 'P - PP (Polypropylene) / S - SS (Stainless Steel)',
          'Dimension': 'S - ID 28 mm; OD 62–65 mm / B - ID 28 mm; OD 110–115 mm',
          'Micron Rating': '01 : 1 µm',
          'End Adaptor / Seal': 'Code 0 - DOE w/o adaptor; E - EPDM',
          'Length Inch': '5 : 5"'
        },
        {
          'Model': '',
          'Material': '',
          'Support Core': '',
          'Dimension': '',
          'Micron Rating': '03 : 3 µm',
          'End Adaptor / Seal': 'Code 7 - 226 / Fin; N - Buna',
          'Length Inch': '10 : 10"'
        },
        {
          'Model': '',
          'Material': '',
          'Support Core': '',
          'Dimension': '',
          'Micron Rating': '05 : 5 µm',
          'End Adaptor / Seal': 'Code 8 - 222 / Fin; S - Silicone',
          'Length Inch': '20 : 20"'
        },
        {
          'Model': '',
          'Material': '',
          'Support Core': '',
          'Dimension': '',
          'Micron Rating': '10 : 10 µm',
          'End Adaptor / Seal': 'Code 3 - 222 / Flat Closed; V - Viton',
          'Length Inch': '30 : 30"'
        },
        {
          'Model': '',
          'Material': '',
          'Support Core': '',
          'Dimension': '',
          'Micron Rating': '…… (other options)',
          'End Adaptor / Seal': '(other codes as applicable)',
          'Length Inch': '40 : 40"'
        },
        {
          'Model': '',
          'Material': '',
          'Support Core': '',
          'Dimension': '',
          'Micron Rating': '…… (up to 150 µm)',
          'End Adaptor / Seal': '',
          'Length Inch': '50 : 50" / 60 : 60"'
        }
      ]
    },
    models: [
      {
        model: 'SW-PP-01-5',
        media: 'Polypropylene (PP) yarn',
        core: 'PP core',
        micronRating: '1 µm',
        endAdaptor: 'DOE / No adaptor',
        seal: 'EPDM',
        length: '5"'
      },
      {
        model: 'SW-COT-03-10',
        media: 'Cotton yarn',
        core: 'SS core',
        micronRating: '3 µm',
        endAdaptor: '226 / Fin',
        seal: 'Buna',
        length: '10"'
      },
      {
        model: 'SW-GF-05-20',
        media: 'Glass Fiber yarn',
        core: 'SS core',
        micronRating: '5 µm',
        endAdaptor: '222 / Fin',
        seal: 'Silicone',
        length: '20"'
      },
      {
        model: 'SW-PP-10-30',
        media: 'Polypropylene (PP) yarn',
        core: 'PP core',
        micronRating: '10 µm',
        endAdaptor: '222 / Flat Closed',
        seal: 'Viton',
        length: '30"'
      }
    ]
  },
  'ssp': {
    id: 'ssp',
    title: 'SSP Stainless Steel Pleated Cartridge Filters',
    name: 'SSP Stainless Steel Pleated Cartridge Filters',
    shortDescription: 'Stainless steel pleated cartridges offering accurate ratings, low pressure drop and cleanability for demanding industrial applications.',
    description: 'SSP stainless steel pleated cartridge filters are manufactured from SS304 / SS316L sintered fiber web or wire woven cloth to provide robust, cleanable and long-life filtration with high porosity and low pressure drop.',
    longDescription: 'SSP Stainless Steel Pleated Cartridge Filters deliver reliable, accurate filtration for chemical, petrochemical, pharmaceutical and high-temperature applications. Constructed with stainless steel media and SS304/SS316L cores/cages/end adaptors, these pleated cartridges are chemically and thermally robust, easily cleaned by conventional chemical methods and offer extended service life. The pleated design increases filtration area while maintaining low differential pressure.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/f4e47a572c3a78d25d6cb5d299281ae0.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'High reliable standard specifications',
      'Low pressure drop due to high porosity',
      'Accurate filtration rating',
      'Easily cleanable by conventional chemical cleaning and long service life',
      'Pleated design increases the filtration area'
    ],
    applications: [
      'Chemical processing',
      'Petrochemical and refinery systems',
      'Pharmaceutical and biotech',
      'Food & beverage (where stainless media required)',
      'Power generation and utilities',
      'High temperature or corrosive fluid filtration'
    ],
    specifications: {
      'Filter Media': 'SS304 / SS316L sintered fiber web; SS304 / SS316L wire woven cloth',
      'Support Layer': 'Stainless Steel (SS)',
      'Core / Cage / End Adaptor': 'SS304 / SS316L',
      'Seal Material': 'Silicone, EPDM, Buna, Viton, Teflon',
      'Outer Diameter': '65 mm',
      'Nominal Lengths': '5", 10", 20", 30", 40"',
      'Micron Rating': '1, 3, 5 ... µm',
      'Notes': 'Robust stainless construction suitable for chemical cleaning and high-temperature environments'
    },
    technicalData: {
      'Ordering Guide': [
        {
          'Model': 'SSP — Stainless Steel Pleated Cartridge Filters',
          'Media': 'SS304 / SS316L sintered fiber web; SS304 / SS316L wire woven cloth',
          'Micron Rating': '1, 3, 5 ... µm',
          'Core / Cage / End Adaptor': 'SS304 / SS316L',
          'Seal': 'Silicone; EPDM; Buna; Viton; Teflon',
          'Length': '5", 10", 20", 30", 40"'
        }
      ]
    },
    models: [
      {
        model: 'SSP-304-SW-1-10',
        media: 'SS304 sintered fiber web',
        micronRating: '1 µm',
        core: 'SS304',
        endAdaptor: 'SS304',
        seal: 'EPDM',
        length: '10"'
      },
      {
        model: 'SSP-316L-WW-3-20',
        media: 'SS316L wire woven cloth',
        micronRating: '3 µm',
        core: 'SS316L',
        endAdaptor: 'SS316L',
        seal: 'Viton',
        length: '20"'
      },
      {
        model: 'SSP-316L-SW-5-40',
        media: 'SS316L sintered fiber web',
        micronRating: '5 µm',
        core: 'SS316L',
        endAdaptor: 'SS316L',
        seal: 'Teflon',
        length: '40"'
      }
    ]
  },
  'softener-resin': {
    id: 'softener-resin',
    title: 'Softener Resin Filter Cartridge',
    name: 'Softener Resin Filter Cartridge',
    shortDescription: 'Cartridge made purely of ion-exchange resin for water softening; protects equipment from scale by removing Ca²⁺ and Mg²⁺.',
    description: 'Ion-exchange resin cartridge (cation exchange, sodium form) for point-of-use or point-of-entry softening to reduce hardness and protect downstream equipment. Disposable or regenerable depending on configuration.',
    longDescription: 'The Softener Resin Filter Cartridge contains ion-exchange resin in a cartridge format to remove calcium and magnesium ions from water by replacing them with sodium ions. Intended for point-of-use or point-of-entry applications where scale protection is required. Regeneration and service life depend on feedwater hardness, flowrate and resin volume; confirm intended use with supplier.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/98fc73a41bd3739b2a4129e23f0fa4c1.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'Cartridge made purely of ion-exchange resin (cation exchange, sodium form)',
      'Removes calcium and magnesium ions by ion exchange to soften water',
      'Protects appliances and systems from scale deposits',
      'Suitable for point-of-use and light commercial softening (subject to sizing)',
      'Disposable or regenerable options depending on design'
    ],
    applications: [
      'Domestic water softening (appliances, water heaters, boilers)',
      'Pre-treatment to protect downstream equipment from scale',
      'Light commercial softening applications (subject to sizing)'
    ],
    specifications: {
      'Media': 'Ion-exchange resin (cation exchange resin, sodium form)',
      'Support / Drainage': 'Typically Polypropylene (PP) - manufacturer dependent',
      'Core / End Adaptors': 'Typically Polypropylene or plastic composite - confirm with supplier',
      'Seal Material': 'EPDM, Buna, Silicone, Viton (confirm compatibility)',
      'Micron Rating': 'N/A (bulk ion-exchange media; not a particulate depth filter)',
      'Common Lengths (examples)': '10", 20", 40" (other lengths possible)',
      'Notes': 'Regeneration may be required or cartridges may be disposable — confirm intended use. Performance (capacity, service flowrate) depends on resin volume and feedwater hardness.'
    },
    technicalData: {
      'Typical Notes': [
        { 'Note': 'This cartridge is a bulk resin element; micron rating is not applicable for particle removal.' },
        { 'Note': 'Regeneration and service life depend on feedwater hardness, flowrate and resin volume; supplier specification required for design.' },
        { 'Note': 'Provide feedwater hardness and desired service interval for sizing recommendations.' }
      ],
      'Cartridge Dimensions (examples)': [
        { 'Length Option': '10"', 'Comment': 'Common nominal length; confirm OD/volume with supplier' },
        { 'Length Option': '20"', 'Comment': 'Common nominal length; confirm OD/volume with supplier' },
        { 'Length Option': '40"', 'Comment': 'Common nominal length; confirm OD/volume with supplier' }
      ],
      'Ordering Guide (example)': [
        {
          'Model': 'SR - Softener Resin Type',
          'Media': 'Cation Exchange Resin (Na+ form)',
          'Micron Rating': 'N/A (ion-exchange media)',
          'Core / End Adaptor': 'PP / plastic composite (typical) - confirm',
          'Seal': 'E - EPDM; N - Buna; S - Silicone; V - Viton (options)',
          'Length': '10, 20, 40 (inch typical)'
        }
      ]
    },
    models: [
      {
        model: 'SR-10-NA-E',
        media: 'Ion-exchange cation resin (Na form)',
        config: 'Disposable bulk resin cartridge',
        seal: 'EPDM',
        length: '10"'
      },
      {
        model: 'SR-20-NA-N',
        media: 'Ion-exchange cation resin (Na form)',
        config: 'Disposable bulk resin cartridge',
        seal: 'Buna',
        length: '20"'
      },
      {
        model: 'SR-40-NA-V',
        media: 'Ion-exchange cation resin (Na form)',
        config: 'High-capacity bulk resin cartridge',
        seal: 'Viton',
        length: '40"'
      }
    ]
  },
  'pcp-series': {
    id: 'pcp-series',
    title: 'PCP Series Polyester Cellulose Pleated Cartridge Filters',
    name: 'PCP Series Polyester Cellulose Pleated Cartridge Filters',
    shortDescription: 'Pleated polyester cellulose cartridges with high dirt-holding capacity and low pressure drop for general water filtration.',
    description: 'Pleated polyester cellulose media designed for general water and RO treatment, residential & commercial water, and a variety of industrial liquid filtration applications.',
    longDescription: 'PCP Series Polyester Cellulose Pleated Cartridge Filters feature pleated polyester-cellulose media that increases filtration surface area and maximizes dirt-holding capacity. Designed for general water filtration, the polyester cellulose media offers good resistance to bacteria and many chemicals. Available in multiple dimensions and lengths, PCP cartridges provide low pressure drop and high flow for residential, commercial and industrial uses.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/ff7d1ffd7e177aa02c5ee50dc6c32601.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'Pleated design increases filtration surface area',
      'Maximizes dirt-holding capacity',
      'Designed for general water filtration purposes',
      'Polyester cellulose media is bacteria- and chemical-resistant',
      'Versatile and reusable for a variety of uses',
      'Low pressure drop, high flowrate'
    ],
    applications: [
      'General water and R.O. treatment',
      'Residential & commercial water treatment',
      'Acid/base liquid filtration in chemical processing',
      'Industrial chemicals and organic solvents',
      'Processing of sterile water and ultrapure water',
      'Industrial water and plating liquid'
    ],
    specifications: {
      'Media': 'Polyester Cellulose',
      'Core': 'Polypropylene (PP)',
      'End Caps': 'Vinyl plastisol',
      'Max. Differential Pressure': '4.0 bar @ 20°C',
      'Recommended Change-out Differential': '1–1.5 bar',
      'Max. Operating Temperature': '52°C',
      'Flow Rate': '3–10 GPM per 10\" length (depends on removal rating)',
      'Removal Ratings (µm)': '1, 5, … up to 50 µm',
      'Outer Diameter Options': 'OD 68 mm; OD 115 mm (depending on end type)',
      'Nominal Lengths': '10\", 20\", 30\", 40\"'
    },
    technicalData: {
      'Pressure Drop vs Flowrate (LPM - PSI)': [
        { 'Flowrate (LPM)': '5',  '1 µm (PSI)': '0.25', '5 µm (PSI)': '0.22', '10 µm (PSI)': '0.18', '25 µm (PSI)': '0.14', '50 µm (PSI)': '0.12' },
        { 'Flowrate (LPM)': '10', '1 µm (PSI)': '0.90', '5 µm (PSI)': '0.80', '10 µm (PSI)': '0.60', '25 µm (PSI)': '0.50', '50 µm (PSI)': '0.40' },
        { 'Flowrate (LPM)': '15', '1 µm (PSI)': '1.80', '5 µm (PSI)': '1.60', '10 µm (PSI)': '1.15', '25 µm (PSI)': '0.95', '50 µm (PSI)': '0.80' },
        { 'Flowrate (LPM)': '20', '1 µm (PSI)': '3.00', '5 µm (PSI)': '2.60', '10 µm (PSI)': '1.90', '25 µm (PSI)': '1.45', '50 µm (PSI)': '1.25' },
        { 'Flowrate (LPM)': '25', '1 µm (PSI)': '4.50', '5 µm (PSI)': '3.80', '10 µm (PSI)': '2.75', '25 µm (PSI)': '2.10', '50 µm (PSI)': '1.80' },
        { 'Flowrate (LPM)': '30', '1 µm (PSI)': '6.20', '5 µm (PSI)': '5.20', '10 µm (PSI)': '3.30', '25 µm (PSI)': '2.80', '50 µm (PSI)': '2.55' },
        { 'Flowrate (LPM)': '35', '1 µm (PSI)': '8.20', '5 µm (PSI)': '6.80', '10 µm (PSI)': '4.60', '25 µm (PSI)': '3.95', '50 µm (PSI)': '3.55' },
        { 'Flowrate (LPM)': '40', '1 µm (PSI)': '10.00','5 µm (PSI)': '9.20', '10 µm (PSI)': '8.00', '25 µm (PSI)': '7.20', '50 µm (PSI)': '6.30' }
      ],
      'Ordering Guide': [
        { 'Model': 'PCP — Polyester Cellulose Pleated', 'Micron Rating': '01 : 1 µm', 'Dimension': 'S – ID 28 mm; OD 68 mm', 'Length Inch': '10 : 10"' },
        { 'Model': '', 'Micron Rating': '05 : 5 µm', 'Dimension': 'B – ID 28 mm; OD 115 mm', 'Length Inch': '20 : 20"' },
        { 'Model': '', 'Micron Rating': '10 : 10 µm', 'Dimension': 'OD 68 / OD 115 mm (depending on end type)', 'Length Inch': '30 : 30"' },
        { 'Model': '', 'Micron Rating': '25 : 25 µm', 'Dimension': '(other dimensions/options as applicable)', 'Length Inch': '40 : 40"' }
      ]
    },
    models: [
      {
        model: 'PCP-01-S-10',
        media: 'Polyester Cellulose',
        micronRating: '1 µm',
        dimension: 'ID 28 mm; OD 68 mm',
        endType: 'Vinyl plastisol end caps',
        length: '10"'
      },
      {
        model: 'PCP-05-B-20',
        media: 'Polyester Cellulose',
        micronRating: '5 µm',
        dimension: 'ID 28 mm; OD 115 mm',
        endType: 'Vinyl plastisol end caps',
        length: '20"'
      },
      {
        model: 'PCP-10-68-30',
        media: 'Polyester Cellulose',
        micronRating: '10 µm',
        dimension: 'OD 68 mm',
        endType: 'Vinyl plastisol end caps',
        length: '30"'
      },
      {
        model: 'PCP-25-115-40',
        media: 'Polyester Cellulose',
        micronRating: '25 µm',
        dimension: 'OD 115 mm',
        endType: 'Vinyl plastisol end caps',
        length: '40"'
      }
    ]
  },
  'nominal-pp': {
    id: 'nominal-pp',
    title: 'Nominal Rated PP Melt Blown / Spun Cartridge Filters',
    name: 'Nominal Rated PP Melt Blown / Spun Cartridge Filters',
    shortDescription: 'Nominal-rated PP melt blown / spun cartridges with dual-gradient density for high dirt-holding capacity and low pressure drop.',
    description: 'High-performance 100% polypropylene depth media with dual-gradient density for excellent capacity and efficiency. Suitable for drinking water, RO pre-filtration, food & beverage and industrial chemical applications.',
    longDescription: 'PM Series Nominal Rated PP Melt Blown / Spun Cartridge Filters combine an outer pre-filter section with an inner compact rated section to provide graded density retention through the cross-section. Manufactured from pure PP microfiber under controlled conditions, PM cartridges deliver consistent performance, high strength and pressure resistance, and are thermally bonded without binders or adhesives.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/56d1f11239a2eccd172381712d3f8e5a.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'Surface pore structure spreads flow to reduce pressure drop',
      'Continuously gradient pore structure increases dirt-holding capacity and service life',
      'High strength and pressure resistance',
      'Micro-denier melt blown filtration fiber with high removal ratings',
      '100% polypropylene construction for wide chemical compatibility',
      'Thermally bonded manufacturing without binders or adhesives'
    ],
    applications: [
      'Drinking water treatment',
      'Pre-filtration for RO and DI systems',
      'Food & beverage processing',
      'Plating, chemicals and solvent filtration'
    ],
    specifications: {
      'Material': '100% PP microfiber',
      'Micron Rating': '1, 3, 5, 10, ... up to 100 µm (nominal)',
      'Outer Diameter': '62–65 mm or 110–115 mm',
      'Inner Diameter': '28 mm',
      'Lengths': '5", 10", 20", 30", 40", 50", 60"',
      'Max Differential Pressure': '4.1 bar @ 20°C; 2.1 bar @ 60°C; 1.1 bar @ 80°C',
      'Recommended Change-out': '2.0 bar',
      'Max Operating Temperature': '80°C'
    },
    technicalData: {
      'Dual-Gradient Density Media Rating': [
        {
          'Nominal Micron Rating (µm)': '1, 3, 5, 10, 25, 50',
          'Outer Pre-Filter Media (µm)': '25, 25, 50, 50, 75, 100',
          'Inner Compact Media (µm)': '1, 3, 5, 10, 25, 50'
        }
      ],
      'Dirt Holding Capacity (Gram per 10\" L)': [
        { 'Micron Rating (µm)': '1',  'Dirt Holding Capacity (Gram / 10\" L)': '> 15' },
        { 'Micron Rating (µm)': '3',  'Dirt Holding Capacity (Gram / 10\" L)': '> 20' },
        { 'Micron Rating (µm)': '5',  'Dirt Holding Capacity (Gram / 10\" L)': '> 30' },
        { 'Micron Rating (µm)': '10', 'Dirt Holding Capacity (Gram / 10\" L)': '> 60' },
        { 'Micron Rating (µm)': '25', 'Dirt Holding Capacity (Gram / 10\" L)': '> 120' },
        { 'Micron Rating (µm)': '50', 'Dirt Holding Capacity (Gram / 10\" L)': '> 150' }
      ],
      'Pressure Drop vs Flowrate (LPM - PSI)': [
        { 'Flowrate (LPM)': '5',  '1 µm (PSI)': '0.25', '5 µm (PSI)': '0.22', '10 µm (PSI)': '0.18', '25 µm (PSI)': '0.14', '50 µm (PSI)': '0.12' },
        { 'Flowrate (LPM)': '10', '1 µm (PSI)': '0.90', '5 µm (PSI)': '0.80', '10 µm (PSI)': '0.60', '25 µm (PSI)': '0.50', '50 µm (PSI)': '0.40' },
        { 'Flowrate (LPM)': '15', '1 µm (PSI)': '1.80', '5 µm (PSI)': '1.60', '10 µm (PSI)': '1.15', '25 µm (PSI)': '0.95', '50 µm (PSI)': '0.80' },
        { 'Flowrate (LPM)': '20', '1 µm (PSI)': '3.00', '5 µm (PSI)': '2.60', '10 µm (PSI)': '1.90', '25 µm (PSI)': '1.45', '50 µm (PSI)': '1.25' },
        { 'Flowrate (LPM)': '25', '1 µm (PSI)': '4.50', '5 µm (PSI)': '3.80', '10 µm (PSI)': '2.75', '25 µm (PSI)': '2.10', '50 µm (PSI)': '1.80' },
        { 'Flowrate (LPM)': '30', '1 µm (PSI)': '6.20', '5 µm (PSI)': '5.20', '10 µm (PSI)': '3.30', '25 µm (PSI)': '2.80', '50 µm (PSI)': '2.55' },
        { 'Flowrate (LPM)': '35', '1 µm (PSI)': '8.20', '5 µm (PSI)': '6.80', '10 µm (PSI)': '4.60', '25 µm (PSI)': '3.95', '50 µm (PSI)': '3.55' },
        { 'Flowrate (LPM)': '40', '1 µm (PSI)': '10.00','5 µm (PSI)': '9.20', '10 µm (PSI)': '8.00', '25 µm (PSI)': '7.20', '50 µm (PSI)': '6.30' }
      ],
      'Pressure Drop vs Flowrate (kg/cm² per 10\")': [
        { 'Flowrate (LPM per 10")': '2',  '1 µm (kg/cm²)': '0.006', '3 µm (kg/cm²)': '0.005', '5 µm (kg/cm²)': '0.005', '10 µm (kg/cm²)': '0.003', '25 µm (kg/cm²)': '0.002', '50 µm (kg/cm²)': '0.001' },
        { 'Flowrate (LPM per 10")': '4',  '1 µm (kg/cm²)': '0.012', '3 µm (kg/cm²)': '0.011', '5 µm (kg/cm²)': '0.010', '10 µm (kg/cm²)': '0.006', '25 µm (kg/cm²)': '0.004', '50 µm (kg/cm²)': '0.002' },
        { 'Flowrate (LPM per 10")': '6',  '1 µm (kg/cm²)': '0.018', '3 µm (kg/cm²)': '0.017', '5 µm (kg/cm²)': '0.015', '10 µm (kg/cm²)': '0.009', '25 µm (kg/cm²)': '0.006', '50 µm (kg/cm²)': '0.003' },
        { 'Flowrate (LPM per 10")': '8',  '1 µm (kg/cm²)': '0.024', '3 µm (kg/cm²)': '0.023', '5 µm (kg/cm²)': '0.020', '10 µm (kg/cm²)': '0.012', '25 µm (kg/cm²)': '0.008', '50 µm (kg/cm²)': '0.004' },
        { 'Flowrate (LPM per 10")': '10', '1 µm (kg/cm²)': '0.030', '3 µm (kg/cm²)': '0.028', '5 µm (kg/cm²)': '0.025', '10 µm (kg/cm²)': '0.015', '25 µm (kg/cm²)': '0.010', '50 µm (kg/cm²)': '0.005' },
        { 'Flowrate (LPM per 10")': '15', '1 µm (kg/cm²)': '0.045', '3 µm (kg/cm²)': '0.042', '5 µm (kg/cm²)': '0.037', '10 µm (kg/cm²)': '0.022', '25 µm (kg/cm²)': '0.015', '50 µm (kg/cm²)': '0.008' },
        { 'Flowrate (LPM per 10")': '20', '1 µm (kg/cm²)': '0.060', '3 µm (kg/cm²)': '0.055', '5 µm (kg/cm²)': '0.049', '10 µm (kg/cm²)': '0.030', '25 µm (kg/cm²)': '0.020', '50 µm (kg/cm²)': '0.010' }
      ],
      'Ordering Guide': [
        { 'Model': 'PM-1 — Standard', 'Media Type': 'P-High Performance', 'Support Core': 'P = PP', 'Dimension': 'S — ID 28 mm; OD 62–65 mm', 'Micron Rating': '01 : 1 µm', 'End Adaptor': 'Code 0 - DOE (w/o adaptor)', 'Seal': 'E - EPDM', 'Length Inch': '5 : 5"' },
        { 'Model': 'PM-2 — Thin Groove', 'Media Type': 'P-High Performance', 'Support Core': 'P = PP', 'Dimension': 'B — ID 28 mm; OD 110–115 mm', 'Micron Rating': '03 : 3 µm', 'End Adaptor': 'Code 7 - 226 / Fin', 'Seal': 'N - Buna', 'Length Inch': '10 : 10"' },
        { 'Model': 'PM-3 — Broad Groove', 'Media Type': 'A — Absolute Rate', 'Support Core': 'N = none', 'Dimension': 'L — ID 96 / 114 mm; OD 150 mm', 'Micron Rating': '05 : 5 µm', 'End Adaptor': 'Code 8 - 222 / Fin', 'Seal': 'S - Silicone', 'Length Inch': '20 : 20"' },
        { 'Model': 'PM-4 — Cavity Surface', 'Media Type': '(surface type)', 'Support Core': 'P = PP / N = none', 'Dimension': 'OD 62–115 mm (various)', 'Micron Rating': '10 : 10 µm', 'End Adaptor': 'Code 3 - 222 / Flat Closed', 'Seal': 'V - Viton', 'Length Inch': '30 : 30"' },
        { 'Model': '', 'Media Type': '', 'Support Core': '', 'Dimension': '', 'Micron Rating': '25 : 25 µm', 'End Adaptor': 'Code S - Spring Cap', 'Seal': '', 'Length Inch': '40 : 40"' },
        { 'Model': '', 'Media Type': '', 'Support Core': '', 'Dimension': '', 'Micron Rating': '50 : 50 µm (and up to 100 µm)', 'End Adaptor': '(other codes as applicable)', 'Seal': '', 'Length Inch': '50 : 50\" / 60 : 60\"' }
      ]
    },
    models: [
      {
        model: 'PM-01-5-P-62',
        media: '100% PP microfiber',
        micronRating: '1 µm',
        od: '62–65 mm',
        id: '28 mm',
        length: '5"'
      },
      {
        model: 'PM-03-10-P-110',
        media: '100% PP microfiber',
        micronRating: '3 µm',
        od: '110–115 mm',
        id: '28 mm',
        length: '10"'
      },
      {
        model: 'PM-05-20-P-62',
        media: '100% PP microfiber',
        micronRating: '5 µm',
        od: '62–65 mm',
        id: '28 mm',
        length: '20"'
      },
      {
        model: 'PM-10-40-P-62',
        media: '100% PP microfiber',
        micronRating: '10 µm',
        od: '62–65 mm',
        id: '28 mm',
        length: '40"'
      }
    ]
  },
  'lds': {
    id: 'lds',
    title: 'LDS Lenticular Disc Stack Filter Cartridge',
    name: 'LDS Lenticular Disc Stack Filter Cartridge',
    shortDescription: 'Backwashable lenticular disc stack modules with rigid separators for high throughput, hot sanitization compatibility and robust module stability.',
    description: 'Lenticular disc stack filter cartridges providing high total throughput, backwashability and increased filtration security via fully supporting separators. Suitable for particle removal, polishing, final (germ) filtration, clarification and colloid removal.',
    longDescription: 'LDS Lenticular Disc Stack Filter Cartridge modules are designed for high-throughput, robust filtration with rigid external clips to prevent damage during module loading/unloading. The separator-supported discs avoid sheet deformities after heat treatment and enable hot sanitization / high-temperature process filtration. Available in multiple disc diameters and cell counts to meet different capacity and throughput demands. Ideal for particle removal, polishing, final (germ) filtration, colloid removal and pre-filtration prior to membrane systems.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/43ee63bdf10e9c6cac46cc527cc07299.png',
    category: 'MF Filter Cartridge',
    features: [
      'Backwashable for high total throughput',
      'Rigid external clips prevent damage during module handling',
      'No filter sheet deformities after heat treatment',
      'Compatible with hot sanitization and high-temperature filtration',
      'Separators fully support sheet material and improve module stability',
      'Suitable for particle removal, polishing, final (germ) filtration and clarification'
    ],
    applications: [
      'Particle removal',
      'Polishing filtration',
      'Final filtration (germ removal)',
      'Clarifying filtration',
      'Colloid removal',
      'Pre-filtration prior to final membrane filters'
    ],
    specifications: {
      'Depth Filter Media': 'Cellulose fibers, diatomaceous earth, perlite, resins (media dependent)',
      'Core / Separator': 'Polypropylene (PP)',
      'End Caps / Module Housing': 'Polypropylene (PP)',
      'Adjustable Flange': 'Polypropylene (PP)',
      'Seal / O-ring / Gasket Options': 'Silicone, EPDM, Buna, Viton',
      'Disc Outside Diameter Options': '8", 12", 16"',
      'Module Configurations': 'Multiple cell counts (see Ordering Guide)',
      'Notes': 'Confirm micron rating, disc diameter, cell count, seal and end adaptor with supplier for proper sizing'
    },
    technicalData: {
      'Ordering Guide': [
        { 'Model': 'LDS - Lenticular Disc stack type', 'Disc Dia.': '08 - 8"', 'Construction': '07 : 7 cells', 'Micron Rating': '020 : 0.2 µm', 'Seal': 'E - EPDM', 'End Adaptor': 'S : Double seal' },
        { 'Model': '', 'Disc Dia.': '12 - 12"', 'Construction': '08 : 8 cells', 'Micron Rating': '045 : 0.45 µm', 'Seal': 'N - Buna', 'End Adaptor': 'O : O‑ring' },
        { 'Model': '', 'Disc Dia.': '16 - 16"', 'Construction': '09 : 9 cells', 'Micron Rating': '300 : 3 µm', 'Seal': 'S - Silicone', 'End Adaptor': 'D : Flat gasket' },
        { 'Model': '', 'Disc Dia.': '', 'Construction': '12 : 12 cells', 'Micron Rating': '......', 'Seal': 'V - Viton', 'End Adaptor': '' },
        { 'Model': '', 'Disc Dia.': '', 'Construction': '14 : 14 cells', 'Micron Rating': '......', 'Seal': 'T - Teflon encapsulated Viton', 'End Adaptor': '' },
        { 'Model': '', 'Disc Dia.': '', 'Construction': '15 : 15 cells', 'Micron Rating': 'H10 : 10 µm', 'Seal': '', 'End Adaptor': '' },
        { 'Model': '', 'Disc Dia.': '', 'Construction': '16 : 16 cells', 'Micron Rating': '', 'Seal': '', 'End Adaptor': '' }
      ]
    },
    models: [
      {
        model: 'LDS-08-07-020-E-S',
        discDiameter: '8"',
        cellCount: '7',
        micronRating: '0.2 µm',
        seal: 'EPDM',
        endAdaptor: 'Double seal'
      },
      {
        model: 'LDS-12-08-045-N-O',
        discDiameter: '12"',
        cellCount: '8',
        micronRating: '0.45 µm',
        seal: 'Buna',
        endAdaptor: 'O-ring'
      },
      {
        model: 'LDS-16-09-300-S-D',
        discDiameter: '16"',
        cellCount: '9',
        micronRating: '3 µm',
        seal: 'Silicone',
        endAdaptor: 'Flat gasket'
      }
    ]
  },
  'hfp-series': {
    id: 'hfp-series',
    title: 'HFP Series High Flow Pleated Cartridge Filters',
    name: 'HFP Series High Flow Pleated Cartridge Filters',
    shortDescription: 'High flow pleated cartridges with large surface area, low pressure drop and high dirt holding capacity.',
    description: 'Pleated PP/PE/GF media providing large surface area and depth filtration for longer service life and reduced change frequency.',
    longDescription: 'HFP Series High Flow Pleated Cartridge Filters feature pleated construction to maximize filtration area while maintaining low pressure drop. Available in polypropylene (PP), polyester-cellulose (PE) and glass fiber (GF) media, HFP cartridges are ideal for oil field, power plant and pre-filtration for RO systems. Designed for depth filtration to prolong service life and lower operating costs.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/77cbeb629cffc818d70b8eac62c97e60.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'Large surface area',
      'Superior flow characteristics with very low pressure drop',
      'High dirt holding capacity',
      'Depth filtration provides longer service life',
      'Low cost due to large filter area and reduced labour to change'
    ],
    applications: [
      'Oil field water treatment',
      'Power plant circulated water treatment',
      'Prefiltration for RO systems, DI water',
      'Solvents, selected acids & alkalis, chemical industry',
      'Oil and petroleum industry'
    ],
    specifications: {
      'Filter Media': 'PP, PE, GF (Glass Fiber)',
      'Support Layer': 'Polypropylene (PP)',
      'Core / End Adaptor': 'Polypropylene (PP)',
      'Netting': 'Polyethylene (PE)',
      'Filtration Area': '0.55 m² per 10" length',
      'Outer Diameter': '69 mm',
      'Inner Diameter': '28 mm',
      'Nominal Lengths': '10", 20", 30", 40"',
      'Micron Rating': '1, 2, 5 ... 50 µm',
      'Max. Differential Pressure (Forward)': '75 psi (5.1 bar) at 20°C; 45 psi (3.1 bar) at 65°C',
      'Filter Change Recommended': '36 psi (2.5 bar)',
      'Max. Operating Temperature': '80°C'
    },
    technicalData: {
      'Pressure Drop vs. Flowrate @ 20°C Per 10"': [
        { 'Flowrate (LPM)': '5',  '1 µm (PSI)': '0.03', '2 µm (PSI)': '0.025', '5 µm (PSI)': '0.020', '10 µm (PSI)': '0.018', '20 µm (PSI)': '0.010', '50 µm (PSI)': '0.005' },
        { 'Flowrate (LPM)': '10', '1 µm (PSI)': '0.08', '2 µm (PSI)': '0.07',  '5 µm (PSI)': '0.055', '10 µm (PSI)': '0.045', '20 µm (PSI)': '0.030', '50 µm (PSI)': '0.015' },
        { 'Flowrate (LPM)': '15', '1 µm (PSI)': '0.15', '2 µm (PSI)': '0.12', '5 µm (PSI)': '0.10',  '10 µm (PSI)': '0.08',  '20 µm (PSI)': '0.06',  '50 µm (PSI)': '0.03' },
        { 'Flowrate (LPM)': '20', '1 µm (PSI)': '0.22', '2 µm (PSI)': '0.18', '5 µm (PSI)': '0.15',  '10 µm (PSI)': '0.12',  '20 µm (PSI)': '0.09',  '50 µm (PSI)': '0.05' },
        { 'Flowrate (LPM)': '25', '1 µm (PSI)': '0.30', '2 µm (PSI)': '0.24', '5 µm (PSI)': '0.20',  '10 µm (PSI)': '0.16',  '20 µm (PSI)': '0.12',  '50 µm (PSI)': '0.07' },
        { 'Flowrate (LPM)': '30', '1 µm (PSI)': '0.37', '2 µm (PSI)': '0.30', '5 µm (PSI)': '0.25',  '10 µm (PSI)': '0.20',  '20 µm (PSI)': '0.15',  '50 µm (PSI)': '0.09' },
        { 'Flowrate (LPM)': '35', '1 µm (PSI)': '0.46', '2 µm (PSI)': '0.36', '5 µm (PSI)': '0.30',  '10 µm (PSI)': '0.25',  '20 µm (PSI)': '0.18',  '50 µm (PSI)': '0.11' },
        { 'Flowrate (LPM)': '40', '1 µm (PSI)': '0.55', '2 µm (PSI)': '0.42', '5 µm (PSI)': '0.34',  '10 µm (PSI)': '0.30',  '20 µm (PSI)': '0.21',  '50 µm (PSI)': '0.13' },
        { 'Flowrate (LPM)': '45', '1 µm (PSI)': '0.60', '2 µm (PSI)': '0.48', '5 µm (PSI)': '0.38',  '10 µm (PSI)': '0.34',  '20 µm (PSI)': '0.24',  '50 µm (PSI)': '0.15' }
      ],
      'Ordering Guide': [
        { 'Model': 'HFP - High Flow Standard Pleated', 'Media': 'PP - Polypropylene', 'Micron Rating': '100 : 1 µm', 'End Adaptor (CODE)': 'CODE O - DOE Double Open End', 'Seal': 'E - EPDM', 'Length': '10 : 10"' },
        { 'Model': '', 'Media': 'PE - Polyester Cellulose', 'Micron Rating': '200 : 2 µm', 'End Adaptor (CODE)': 'CODE 3 - 222 / Flat Closed', 'Seal': 'N - Buna', 'Length': '20 : 20"' },
        { 'Model': '', 'Media': 'GF - Glass Fiber', 'Micron Rating': '500 : 5 µm', 'End Adaptor (CODE)': 'CODE 7 - 226 / Fin', 'Seal': 'S - Silicon', 'Length': '30 : 30"' },
        { 'Model': '', 'Media': '', 'Micron Rating': '......', 'End Adaptor (CODE)': '', 'Seal': 'V - Viton', 'Length': '40 : 40"' },
        { 'Model': '', 'Media': '', 'Micron Rating': 'H50 : 50 µm', 'End Adaptor (CODE)': '', 'Seal': 'T - Teflon (encapsulated Viton)', 'Length': '' },
        { 'Model': '', 'Media': '', 'Micron Rating': '......', 'End Adaptor (CODE)': '(other codes available on request)', 'Seal': '', 'Length': '' }
      ]
    },
    models: [
      {
        model: 'HFP-100-PP-O-E-10',
        media: 'Polypropylene (PP)',
        micronRating: '1 µm',
        endAdaptor: 'DOE Double Open End (O)',
        seal: 'EPDM',
        length: '10"'
      },
      {
        model: 'HFP-200-PE-3-N-20',
        media: 'Polyester Cellulose (PE)',
        micronRating: '2 µm',
        endAdaptor: '222 / Flat Closed (3)',
        seal: 'Buna',
        length: '20"'
      },
      {
        model: 'HFP-500-GF-7-S-30',
        media: 'Glass Fiber (GF)',
        micronRating: '5 µm',
        endAdaptor: '226 / Fin (7)',
        seal: 'Silicon',
        length: '30"'
      },
      {
        model: 'HFP-H50-GF-8-V-40',
        media: 'Glass Fiber (GF)',
        micronRating: '50 µm',
        endAdaptor: '222 / Fin (8)',
        seal: 'Viton',
        length: '40"'
      }
    ]
  },
  'diatomaceous-ceramic': {
    id: 'diatomaceous-ceramic',
    title: 'Diatomaceous Ceramic Filter Cartridge',
    name: 'Diatomaceous Ceramic Filter Cartridge',
    shortDescription: 'Double-sided diatomite ceramic cartridge sintered at 1200°C for high strength, chemical stability and micropore filtration for drinking water applications.',
    description: 'Diatomaceous micropore ceramic filter with patented double-sided technology that increases flow while maintaining precision. Excellent mechanical and chemical stability suitable for natural water, groundwater and drinking water filtration.',
    longDescription: 'The Diatomaceous Ceramic Filter Cartridge is manufactured from high-quality diatomite, molded and sintered at 1200°C to provide a robust double-sided microporous ceramic element. The patented double-sided filter technology increases effective flow and maintains filtration precision, delivering high bacterial retention and turbidity reduction for point-of-use, point-of-entry and small community water treatment.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/bea253e0560c70aa14e7e160fe7514e2.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'Manufactured from diatomite and sintered at 1200°C for excellent strength and stability',
      'Double-sided filter technology increases flow while maintaining precision (patented)',
      'High physical and chemical stability in neutral, acidic and alkaline conditions',
      'High bacterial retention and turbidity reduction for improved drinking water quality',
      'Suitable for a wide range of raw natural water, groundwater and drinking water applications'
    ],
    applications: [
      'Point-of-use and point-of-entry drinking water purification',
      'Groundwater and surface water turbidity and bacterial reduction',
      'Pre-filtration ahead of UV or activated carbon treatment',
      'Portable or small community water treatment systems'
    ],
    specifications: {
      'Material': 'Diatomite (ceramic) - double-sided structure',
      'Sintering Temperature': '1200 °C',
      'Typical Max Flow Rate': '7 L/h @ ΔP = 0.0025 MPa (confirm with supplier)',
      'Bacterial Retention': '≈ 99% (manufacturer data)',
      'Turbidity Reduction': '≈ 90% (manufacturer data)',
      'Chemical Compatibility': 'Stable in neutral, acidic and alkaline conditions',
      'Typical Lengths / Diameters': 'Manufacturer specific — confirm (common options: short element formats for point-of-use)',
      'Notes': 'Microporous ceramic element; cleaning/regeneration and backwash suitability must be confirmed with manufacturer'
    },
    technicalData: {
      'Key Technical Parameters': [
        { 'Parameter': 'Model name', 'Value': 'Diatomaceous Ceramic Filter Cartridge' },
        { 'Parameter': 'Sintering temperature', 'Value': '1200 °C' },
        { 'Parameter': 'Maximum flow rate (at ΔP = 0.0025 MPa)', 'Value': '7 L/h' },
        { 'Parameter': 'Bacterial retention rate', 'Value': '99%' },
        { 'Parameter': 'Turbidity improvement (reduction) rate', 'Value': '90%' },
        { 'Parameter': 'Suitable media', 'Value': 'Natural water, groundwater, drinking water' },
        { 'Parameter': 'Patents / Technology', 'Value': 'Double-sided filter technology (three national patents)' }
      ],
      'Operation Notes': [
        { 'Note': 'Performance depends on feedwater quality, pressure and installation configuration.' },
        { 'Note': 'Max flow measured at ΔP = 0.0025 MPa; flow varies with differential pressure.' },
        { 'Note': 'Confirm cleaning/regeneration/backwash options with manufacturer.' }
      ],
      'Ordering Guide (example)': [
        { 'Model': 'DC-01', 'Media': 'Diatomite Ceramic (double-sided)', 'Micron Rating': 'Micropore (not nominal µm)', 'End Fitting': 'Manufacturer-specific', 'Seal Options': 'EPDM/Buna/Viton', 'Length': 'Customer to specify' }
      ]
    },
    models: [
      {
        model: 'DC-01-STD',
        media: 'Diatomite ceramic (double-sided)',
        config: 'Standard point-of-use element',
        nominal: 'Microporous ceramic (particle/biotic reduction)',
        length: 'Vendor specific'
      },
      {
        model: 'DC-01-HI',
        media: 'Diatomite ceramic (double-sided)',
        config: 'High flow / reinforced element',
        nominal: 'Microporous ceramic',
        length: 'Vendor specific'
      }
    ]
  },
  'absolute-pp': {
    id: 'absolute-pp',
    title: 'Absolute Rated PP Melt Blown / Spun Cartridge Filters',
    name: 'Absolute Rated PP Melt Blown / Spun Cartridge Filters',
    shortDescription: 'Absolute-rated PP melt blown/spun cartridges with β5000 (99.98%) efficiency, graded density and high mechanical strength.',
    description: 'High-performance 100% polypropylene absolute-rated depth media providing consistent absolute retention (β5000), high dirt-holding capacity and low pressure drop. Suitable for critical liquid filtration in water, food & beverage and industrial processes.',
    longDescription: 'Absolute Rated PP Melt Blown / Spun Cartridge Filters deliver reliable absolute retention via a dual-gradient structure: outer pre-filter and inner absolute-rated media. Manufactured from 100% PP microfiber with thermal bonding (no binders), these cartridges offer high mechanical strength, broad chemical compatibility and reproducible performance for demanding applications requiring certified retention.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/56d1f11239a2eccd172381712d3f8e5a.jpg',
    category: 'MF Filter Cartridge',
    features: [
      'Absolute ratings (ß5000, 99.98% efficiency)',
      'Surface pore structure spreads flow to reduce pressure drop',
      'Continuously graded density increases dirt-holding capacity',
      'High mechanical strength and pressure resistance',
      '100% polypropylene construction for wide chemical compatibility',
      'Thermally bonded manufacturing without binders or adhesives'
    ],
    applications: [
      'Drinking water treatment',
      'Pre-filtration for RO and DI systems',
      'Food & beverage industry',
      'Plating, chemicals and solvent filtration',
      'Critical liquid filtration requiring absolute retention'
    ],
    specifications: {
      'Material': '100% polypropylene microfiber',
      'Nominal/Absolute Ratings': '1, 3, 5, 10, ... up to 100 µm (absolute ratings, ß5000)',
      'Outer Diameter': '62–65 mm or 110–115 mm',
      'Inner Diameter': '28 mm',
      'Lengths': '5", 10", 20", 30", 40", 50", 60"',
      'Max Differential Pressure': '4.1 bar @ 20°C; 2.1 bar @ 60°C; 1.1 bar @ 80°C',
      'Recommended Change-out': '2.0 bar',
      'Max Operating Temperature': '80°C'
    },
    technicalData: {
      'Pressure Drop vs Flowrate (kg/cm² per 10")': [
        { 'Flowrate (LPM per 10")': '0',  '1 µm (kg/cm²)': '0.000', '3 µm (kg/cm²)': '0.000', '5 µm (kg/cm²)': '0.000', '10 µm (kg/cm²)': '0.000', '25 µm (kg/cm²)': '0.000', '50 µm (kg/cm²)': '0.000' },
        { 'Flowrate (LPM per 10")': '2',  '1 µm (kg/cm²)': '0.006', '3 µm (kg/cm²)': '0.006', '5 µm (kg/cm²)': '0.005', '10 µm (kg/cm²)': '0.003', '25 µm (kg/cm²)': '0.002', '50 µm (kg/cm²)': '0.001' },
        { 'Flowrate (LPM per 10")': '4',  '1 µm (kg/cm²)': '0.012', '3 µm (kg/cm²)': '0.011', '5 µm (kg/cm²)': '0.010', '10 µm (kg/cm²)': '0.006', '25 µm (kg/cm²)': '0.004', '50 µm (kg/cm²)': '0.002' },
        { 'Flowrate (LPM per 10")': '6',  '1 µm (kg/cm²)': '0.018', '3 µm (kg/cm²)': '0.017', '5 µm (kg/cm²)': '0.015', '10 µm (kg/cm²)': '0.009', '25 µm (kg/cm²)': '0.006', '50 µm (kg/cm²)': '0.003' },
        { 'Flowrate (LPM per 10")': '8',  '1 µm (kg/cm²)': '0.024', '3 µm (kg/cm²)': '0.022', '5 µm (kg/cm²)': '0.020', '10 µm (kg/cm²)': '0.012', '25 µm (kg/cm²)': '0.008', '50 µm (kg/cm²)': '0.004' },
        { 'Flowrate (LPM per 10")': '10', '1 µm (kg/cm²)': '0.030', '3 µm (kg/cm²)': '0.028', '5 µm (kg/cm²)': '0.024', '10 µm (kg/cm²)': '0.015', '25 µm (kg/cm²)': '0.010', '50 µm (kg/cm²)': '0.005' },
        { 'Flowrate (LPM per 10")': '12', '1 µm (kg/cm²)': '0.036', '3 µm (kg/cm²)': '0.033', '5 µm (kg/cm²)': '0.029', '10 µm (kg/cm²)': '0.018', '25 µm (kg/cm²)': '0.012', '50 µm (kg/cm²)': '0.006' },
        { 'Flowrate (LPM per 10")': '14', '1 µm (kg/cm²)': '0.042', '3 µm (kg/cm²)': '0.039', '5 µm (kg/cm²)': '0.034', '10 µm (kg/cm²)': '0.021', '25 µm (kg/cm²)': '0.014', '50 µm (kg/cm²)': '0.007' },
        { 'Flowrate (LPM per 10")': '16', '1 µm (kg/cm²)': '0.048', '3 µm (kg/cm²)': '0.044', '5 µm (kg/cm²)': '0.039', '10 µm (kg/cm²)': '0.024', '25 µm (kg/cm²)': '0.016', '50 µm (kg/cm²)': '0.008' },
        { 'Flowrate (LPM per 10")': '18', '1 µm (kg/cm²)': '0.054', '3 µm (kg/cm²)': '0.050', '5 µm (kg/cm²)': '0.044', '10 µm (kg/cm²)': '0.027', '25 µm (kg/cm²)': '0.018', '50 µm (kg/cm²)': '0.009' },
        { 'Flowrate (LPM per 10")': '20', '1 µm (kg/cm²)': '0.060', '3 µm (kg/cm²)': '0.055', '5 µm (kg/cm²)': '0.049', '10 µm (kg/cm²)': '0.030', '25 µm (kg/cm²)': '0.020', '50 µm (kg/cm²)': '0.010' }
      ],
      'Filtration Efficiency (Removal %)': [
        { 'Micron Rating (µm)': '1',  '1 µm (%)': '>99.99%', '3 µm (%)': '>99.99%', '5 µm (%)': '>99.99%', '10 µm (%)': '>99.99%', '25 µm (%)': '>99.99%', '50 µm (%)': '>99.99%' },
        { 'Micron Rating (µm)': '3',  '1 µm (%)': '>88.5%',  '3 µm (%)': '>99.99%', '5 µm (%)': '>99.99%', '10 µm (%)': '>99.99%', '25 µm (%)': '>99.99%', '50 µm (%)': '>99.99%' },
        { 'Micron Rating (µm)': '5',  '1 µm (%)': '>71.3%',  '3 µm (%)': '>92.1%',  '5 µm (%)': '>99.99%', '10 µm (%)': '>99.99%', '25 µm (%)': '>99.99%', '50 µm (%)': '>99.99%' },
        { 'Micron Rating (µm)': '10', '1 µm (%)': '>38.1%',  '3 µm (%)': '>65.4%',  '5 µm (%)': '>86.5%',  '10 µm (%)': '>99.99%', '25 µm (%)': '>99.99%', '50 µm (%)': '>99.99%' },
        { 'Micron Rating (µm)': '25', '1 µm (%)': '>30.6%',  '3 µm (%)': '>41.7%',  '5 µm (%)': '>77.3%',  '10 µm (%)': '>91.5%',  '25 µm (%)': '>99.99%', '50 µm (%)': '>99.99%' },
        { 'Micron Rating (µm)': '50', '1 µm (%)': '>28.9%',  '3 µm (%)': '>33.6%',  '5 µm (%)': '>46.9%',  '10 µm (%)': '>63.2%',  '25 µm (%)': '>81.5%',  '50 µm (%)': '>99.99%' }
      ],
      'Dirt Holding Capacity (Gram per 10\" L)': [
        { 'Micron Rating (µm)': '1',  'Capacity (g / 10\" L)': '> 15' },
        { 'Micron Rating (µm)': '3',  'Capacity (g / 10\" L)': '> 20' },
        { 'Micron Rating (µm)': '5',  'Capacity (g / 10\" L)': '> 30' },
        { 'Micron Rating (µm)': '10', 'Capacity (g / 10\" L)': '> 60' },
        { 'Micron Rating (µm)': '25', 'Capacity (g / 10\" L)': '> 120' },
        { 'Micron Rating (µm)': '50', 'Capacity (g / 10\" L)': '> 150' }
      ],
      'Ordering Guide': [
        { 'Model': 'PM-ABS-1', 'Media Type': 'PP Absolute Rated', 'Support Core': 'P = PP', 'Dimension': 'S — ID 28 mm; OD 62–65 mm', 'Micron Rating': '01 : 1 µm (absolute ß5000)', 'End Adaptor': 'Code 0 - DOE (w/o adaptor)', 'Seal': 'E - EPDM', 'Length Inch': '5 : 5"' },
        { 'Model': 'PM-ABS-3', 'Media Type': 'PP Absolute Rated', 'Support Core': 'P = PP', 'Dimension': 'B — ID 28 mm; OD 110–115 mm', 'Micron Rating': '03 : 3 µm', 'End Adaptor': 'Code 7 - 226 / Fin', 'Seal': 'N - Buna', 'Length Inch': '10 : 10"' },
        { 'Model': 'PM-ABS-5', 'Media Type': 'PP Absolute Rated', 'Support Core': 'P = PP', 'Dimension': 'L — ID 96 / 114 mm; OD 150 mm', 'Micron Rating': '05 : 5 µm', 'End Adaptor': 'Code 8 - 222 / Fin', 'Seal': 'S - Silicone', 'Length Inch': '20 : 20"' },
        { 'Model': 'PM-ABS-10', 'Media Type': 'PP Absolute Rated', 'Support Core': 'P = PP', 'Dimension': 'OD 62–150 mm (various)', 'Micron Rating': '10 : 10 µm', 'End Adaptor': 'Code 3 - 222 / Flat Closed', 'Seal': 'V - Viton', 'Length Inch': '30 : 30"' },
        { 'Model': '', 'Media Type': '', 'Support Core': '', 'Dimension': '', 'Micron Rating': '25 : 25 µm', 'End Adaptor': 'Code S - Spring Cap', 'Seal': '', 'Length Inch': '40 : 40"' },
        { 'Model': '', 'Media Type': '', 'Support Core': '', 'Dimension': '', 'Micron Rating': '50 : 50 µm (and up to 100 µm)', 'End Adaptor': '(other codes as applicable)', 'Seal': '', 'Length Inch': '50 : 50\" / 60 : 60\"' }
      ]
    },
    models: [
      {
        model: 'PM-ABS-01-5-PP-62',
        media: '100% PP microfiber (absolute)',
        micronRating: '1 µm (absolute ß5000)',
        od: '62–65 mm',
        id: '28 mm',
        length: '5"'
      },
      {
        model: 'PM-ABS-03-10-PP-110',
        media: '100% PP microfiber (absolute)',
        micronRating: '3 µm (absolute ß5000)',
        od: '110–115 mm',
        id: '28 mm',
        length: '10"'
      },
      {
        model: 'PM-ABS-05-20-PP-62',
        media: '100% PP microfiber (absolute)',
        micronRating: '5 µm (absolute ß5000)',
        od: '62–65 mm',
        id: '28 mm',
        length: '20"'
      },
      {
        model: 'PM-ABS-10-40-PP-62',
        media: '100% PP microfiber (absolute)',
        micronRating: '10 µm (absolute ß5000)',
        od: '62–65 mm',
        id: '28 mm',
        length: '40"'
      }
    ]
  }
};

export const mfFilterCartridgeProductsList = [
  {
    id: 'hfpc-series',
    name: 'HFPC Series High Flow Pleated Cartridge Filters',
    category: 'MF Filter Cartridge',
    shortDescription: 'Large filter area and depth filtration provides a long lifetime with optimal efficiency of solids removal.',
    description: 'High flow pleated cartridge filters with large filter area and depth filtration for extended lifetime and cost-effective operation.',
    features: [
      'Large filter area and depth filtration for long lifetime',
      'Low cost operation with reduced labor costs',
      'Absolute glass fiber media for optimal efficiency'
    ],
    applications: [
      'Oil field water treatment',
      'Power plant circulated water treatment',
      'Chemical processing'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/085e0fcb805141d581023278e80cc79a.jpg'
  },
  {
    id: 'ptfe-membrane',
    name: 'PTFE Membrane Pleated Filter Cartridge',
    category: 'MF Filter Cartridge',
    shortDescription: 'Hydrophobic PTFE membrane pleated cartridges with absolutely rated filtration for gas and liquid applications.',
    description: 'Superior flow rate and efficiency maximizing performance with extremely good chemical compatibility and high temperature resistance.',
    features: [
      'Hydrophobic PTFE membrane with absolutely rated filtration',
      'Superior flow rate and efficiency maximizing performance',
      'Extremely good chemical compatibility and high temperature resistance'
    ],
    applications: [
      'Solvent filtration',
      'Sterile vent filters for storage tanks',
      'Pharmaceutical and intermediate Solvents'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/883bc7bd103137a0e33ccb3946b167ea.png'
  },
  {
    id: 'pp-membrane',
    name: 'PP Membrane Pleated Filter Cartridge',
    category: 'MF Filter Cartridge',
    shortDescription: 'High surface area polypropylene membrane pleated cartridges with increased dirt holding capacity and longer service life.',
    description: 'Constructed of all polypropylene high purity media, meets FDA requirements with multiple layered micro-porous construction.',
    features: [
      'High surface area for enhanced filtration performance',
      'Increased dirt holding capacity and longer service life',
      'All polypropylene construction meets FDA requirements'
    ],
    applications: [
      'Pre-filtration or RO system, DI water',
      'Food and beverage, drinking water treatment',
      'Semiconductor, Electronic industry ultrapure water system'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/883bc7bd103137a0e33ccb3946b167ea.png'
  },
  {
    id: 'pes-membrane',
    name: 'PES Membrane Pleated Filter Cartridge',
    category: 'MF Filter Cartridge',
    shortDescription: 'Unique hydrophilic polyethersulfone cartridges with absolutely rated filtration and broad chemical compatibility.',
    description: 'Superior chemical compatibility with physiological inertness, 100% integrity tested for consistent and reliable performance.',
    features: [
      'Unique hydrophilic polyethersulfone with absolutely rated filtration',
      'Broad chemical compatibility and physiological inertness',
      '100% integrity tested for consistent performance'
    ],
    applications: [
      'Final filtration for bacteria removal in RO system',
      'Sterilization of food and beverages',
      'Micro-filtration in ultrapure water system'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/883bc7bd103137a0e33ccb3946b167ea.png'
  },
  {
    id: 'nylon-membrane',
    name: 'Nylon Membrane Pleated Filter Cartridge',
    category: 'MF Filter Cartridge',
    shortDescription: 'Hydrophilic Nylon 6 membrane pleated cartridges with absolutely rated performance and non-fiber releasing properties.',
    description: 'Superior flow rate and efficiency with good high temperature, acid and base resistance for pharmaceutics and food industry requirements.',
    features: [
      'Hydrophilic Nylon 6 membrane with absolutely rated performance',
      'Non-fiber releasing according to pharmaceutics and food industry requirements',
      'Good high temperature, acid and base resistance'
    ],
    applications: [
      'Final filtration for bacteria removal in ultrapure water systems',
      'Particle filtration for ultrapure chemicals',
      'Semiconductor / Electronic industry ultrapure water systems'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/883bc7bd103137a0e33ccb3946b167ea.png'
  },
  {
    id: 'wf-series',
    name: 'WF Series Whole Forming Pleated Cartridge Filters',
    category: 'MF Filter Cartridge',
    shortDescription: 'Single whole piece cage and core construction with excellent chemical compatibility and graded pore density for high dirt holding capacity.',
    description: 'Pleated design with low pressure drop and long service life, suitable for filtering organic solvents, acid bases with full range of removal ratings.',
    features: [
      'Single whole piece cage and core construction',
      'Excellent chemical compatibility for organic solvents and acid bases',
      'Graded pore density for high dirt holding capacity'
    ],
    applications: [
      'Pharmaceutics',
      'Food and beverage',
      'Chemical industry'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/376b568642c9b2f87edf3ae50995d6ee.jpg'
  },
  {
    id: 'uhfp-d',
    name: 'UHFP-D Ultra Highflow Bag Filter Cartridge',
    category: 'MF Filter Cartridge',
    shortDescription: 'Ultra-high flow pleated bag cartridge (6\" / 152 mm) for high flow and high contaminant applications, retrofit for size #1 and #2 housings.',
    description: 'Pleated PP high performance media with large filtration area and high dirt holding capacity. Suitable for RO pretreatment, food & beverage, biopharm and industrial water filtration.',
    features: [
      'Large 6\" / 152 mm diameter for very high flow',
      'Pleated PP media with high filtration area',
      'Easily retrofit into existing size #1 and #2 bag housings'
    ],
    applications: [
      'RO prefiltration / seawater desalination pretreatment',
      'Bottled water and food & beverage filtration',
      'Biopharm and API filtration',
      'Petrochemical, paints and refineries'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/ea01f6656e8d2d10a8c1f66c49cf05fb.jpg'
  },
  {
    id: 'uhfp-c',
    name: 'UHFP-C Ultra Highflow Filter Cartridge',
    category: 'MF Filter Cartridge',
    shortDescription: 'Ultra highflow cartridge with 6.5" (165 mm) diameter, high dirt holding capacity and wide chemical compatibility.',
    description: 'Pleated GF or PP media providing long service life and reduced change-outs. O-ring sealing prevents bypass and ensures filtration efficiency.',
    features: [
      'High dirt holding capacity, long service life',
      'Less cartridge change out to save labour cost',
      'O-ring design prevents bypass to ensure filtration efficiency'
    ],
    applications: [
      'Prefiltration of RO / seawater desalination pretreatment',
      'Condensed water treatment for power plants',
      'API / solvent filtration in BioPharm market',
      'Bottled water and food & beverage filtration'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/34a88469f1129ebb54c0bd03436e3a5b.jpg'
  },
  {
    id: 'uhfp-b',
    name: 'UHFP-B Ultra Highflow Filter Cartridge',
    category: 'MF Filter Cartridge',
    shortDescription: 'Ultra highflow cartridge with 6" (152 mm) diameter, high dirt holding capacity and O-ring sealing to prevent bypass.',
    description: 'Pleated GF or PP media offering long service life and reduced labour from fewer change-outs. Suitable for RO pretreatment, power plant water, biopharm and beverage filtration.',
    features: [
      'High dirt holding capacity, long service life',
      'Less cartridge change-out to save labour cost',
      'O-ring design prevents bypass to ensure filtration efficiency'
    ],
    applications: [
      'Prefiltration of RO / seawater desalination pretreatment',
      'Condensed water treatment for power plants',
      'API / solvent filtration in BioPharm market',
      'Bottled water and food & beverage filtration'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/923f96ca58d150076e9f615cb9707cab.jpg'
  },
  {
    id: 'uhfp-a',
    name: 'UHFP-A Ultra Highflow Filter Cartridge',
    category: 'MF Filter Cartridge',
    shortDescription: 'Ultra highflow cartridge with 6" (152 mm) diameter and gradient pore structure; available in 20", 40" and 60" lengths.',
    description: 'Pleated GF, Pleated PP or Melt Blown PP media providing high flowrates and high dirt holding capacity, reducing system footprint and service frequency.',
    features: [
      'Gradient pore structure',
      'High per-cartridge flowrate (typical up to ~110 m³/h)',
      'Available in 20", 40" and 60" lengths'
    ],
    applications: [
      'RO prefiltration / seawater desalination pretreatment',
      'Condensate water and hot water recovery (power generation)',
      'Biopharm API and solvent filtration',
      'Bottled water and food & beverage filtration',
      'Paints & coatings, petrochemical, refineries'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/328bb7ced3435ffd2e66249f8223cff9.jpg'
  },
  {
    id: 'string-wound',
    name: 'String Wound Cartridge Filters',
    category: 'MF Filter Cartridge',
    shortDescription: 'Enhanced string-wound cartridges with improved dirt-holding capacity; nominal ratings 1–150 µm.',
    description: 'String wound cartridges for pre-filtration in beverage, pharmaceutical, plating and industrial applications. Available yarns: PP, Cotton, Glass Fiber; cores: PP or SS.',
    features: [
      'Enhanced wound design provides improved dirt-holding capacity',
      'Long life cycle; FDA listed materials for potable/edible products',
      'Nominal micron rating range: 1–150 µm'
    ],
    applications: [
      'Organic solvents, water, oil, alkalinity solvents, beverage, pharmaceuticals (Cotton wound)',
      'Water, dilute acids, oxidizing agents, plating solutions (PP wound)',
      'Chemicals, organic solvents, strong acid/alkali, high temperature applications (Glass fiber wound)'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/b5ebc937f6c21d9a0b7f0249ed266752.jpg'
  },
  {
    id: 'ssp',
    name: 'SSP Stainless Steel Pleated Cartridge Filters',
    category: 'MF Filter Cartridge',
    shortDescription: 'Stainless steel pleated cartridges with low pressure drop, accurate ratings and cleanability for demanding industrial applications.',
    description: 'Constructed from SS304 / SS316L sintered fiber web or wire woven cloth with SS cores/cages/end adaptors. Suitable for chemical, petrochemical, pharma and high-temperature filtration where cleanability and longevity are required.',
    features: [
      'Low pressure drop due to high porosity',
      'Accurate filtration rating',
      'Easily cleanable and long service life'
    ],
    applications: [
      'Chemical processing',
      'Petrochemical and refinery systems',
      'Pharmaceutical / biotech',
      'Food & beverage (stainless media)',
      'Power generation'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/f4e47a572c3a78d25d6cb5d299281ae0.jpg'
  },
  {
    id: 'softener-resin',
    name: 'Softener Resin Filter Cartridge',
    category: 'MF Filter Cartridge',
    shortDescription: 'Ion-exchange resin cartridge for water softening; protects equipment from scale by removing Ca²⁺ and Mg²⁺.',
    description: 'Cartridge using cation exchange resin (sodium form) for point-of-use or point-of-entry softening. Disposable or regenerable designs available; sizing depends on hardness and desired service interval.',
    features: [
      'Cartridge made purely of ion-exchange resin',
      'Removes calcium and magnesium ions to prevent scale',
      'Suitable for domestic and light commercial softening'
    ],
    applications: [
      'Domestic water softening (appliances, heaters, boilers)',
      'Pre-treatment to protect downstream equipment from scale',
      'Light commercial softening (subject to sizing)'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/98fc73a41bd3739b2a4129e23f0fa4c1.jpg'
  },
  {
    id: 'pcp-series',
    name: 'PCP Series Polyester Cellulose Pleated Cartridge Filters',
    category: 'MF Filter Cartridge',
    shortDescription: 'Pleated polyester cellulose cartridges with high dirt-holding capacity and low pressure drop for general water filtration.',
    description: 'Polyester cellulose pleated media designed for general water, residential/commercial and light industrial filtration with low pressure drop and high flow.',
    features: [
      'Pleated design increases filtration surface area',
      'Maximizes dirt-holding capacity',
      'Polyester cellulose media is bacteria- and chemical-resistant'
    ],
    applications: [
      'General water and RO treatment',
      'Residential & commercial water treatment',
      'Industrial chemicals and plating liquid'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/ff7d1ffd7e177aa02c5ee50dc6c32601.jpg'
  },
  {
  id: 'nominal-pp',
    name: 'Nominal Rated PP Melt Blown / Spun Cartridge Filters',
    category: 'MF Filter Cartridge',
    shortDescription: 'Nominal-rated PP melt blown/spun cartridges with dual-gradient density for high dirt-holding capacity and low pressure drop.',
    description: '100% PP depth media with outer pre-filter and inner compact rated sections for graded retention, high capacity and consistent performance.',
    features: [
      'Continuously gradient pore structure increases dirt-holding capacity',
      'High strength and pressure resistance',
      '100% PP for wide chemical compatibility'
    ],
    applications: [
      'Drinking water treatment',
      'Pre-filtration for RO/DI systems',
      'Food & beverage',
      'Plating and chemical processes'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/56d1f11239a2eccd172381712d3f8e5a.jpg'
  },
  {
    id: 'lds',
    name: 'LDS Lenticular Disc Stack Filter Cartridge',
    category: 'MF Filter Cartridge',
    shortDescription: 'Backwashable lenticular disc stack modules with rigid separators for high throughput and hot sanitization compatibility.',
    description: 'Lenticular disc stack modules for particle removal, polishing, final (germ) filtration and clarification; available in 8", 12", 16" disc diameters and multiple cell counts.',
    features: [
      'Backwashable for high total throughput',
      'Rigid external clips and separator support improve module stability',
      'Compatible with hot sanitization and high-temperature filtration'
    ],
    applications: [
      'Particle removal and polishing',
      'Final filtration (germ removal)',
      'Clarifying filtration and colloid removal',
      'Pre-filtration prior to membrane systems'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/43ee63bdf10e9c6cac46cc527cc07299.png'
  },
  {
    id: 'hfp-series',
    name: 'HFP Series High Flow Pleated Cartridge Filters',
    category: 'MF Filter Cartridge',
    shortDescription: 'High flow pleated cartridges with large surface area, low pressure drop and high dirt holding capacity.',
    description: 'Pleated PP/PE/GF media providing large surface area and depth filtration for longer service life and reduced change frequency.',
    features: [
      'Large surface area',
      'Superior flow characteristics with very low pressure drop',
      'High dirt holding capacity'
    ],
    applications: [
      'Oil field water treatment',
      'Power plant circulated water treatment',
      'Prefiltration for RO systems'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/77cbeb629cffc818d70b8eac62c97e60.jpg'
  },
  {
  id: 'diatomaceous-ceramic',
    name: 'Diatomaceous Ceramic Filter Cartridge',
    category: 'MF Filter Cartridge',
    shortDescription: 'Double-sided diatomite ceramic cartridge sintered at 1200°C for high strength and micropore filtration (drinking water quality).',
    description: 'Patented double-sided diatomite ceramic element offering high bacterial retention and turbidity reduction; suited for point-of-use and small community water treatment.',
    features: [
      'Double-sided diatomite ceramic sintered at 1200°C',
      'High bacterial retention and turbidity reduction',
      'Suitable for drinking water and groundwater filtration'
    ],
    applications: [
      'Point-of-use and point-of-entry drinking water purification',
      'Groundwater and surface water treatment',
      'Pre-filtration prior to UV or activated carbon'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/bea253e0560c70aa14e7e160fe7514e2.jpg'
  },
  {
  id: 'absolute-pp',
    name: 'Absolute Rated PP Melt Blown / Spun Cartridge Filters',
    category: 'MF Filter Cartridge',
    shortDescription: 'Absolute-rated PP melt blown/spun cartridges (ß5000) with graded density and high dirt-holding capacity.',
    description: '100% PP absolute-rated depth media with outer pre-filter and inner absolute section for consistent absolute retention and high capacity.',
    features: [
      'Absolute ratings (ß5000, 99.98% efficiency)',
      'Continuously graded density increases dirt holding capacity',
      'High mechanical strength and thermal-bonded construction'
    ],
    applications: [
      'Drinking water treatment',
      'RO/DI pre-filtration',
      'Food & beverage',
      'Plating and chemical processes'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/56d1f11239a2eccd172381712d3f8e5a.jpg'
  }
];

export default mfFilterCartridgeProducts;